import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Checkbox,
  createFilterOptions,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  InputAdornment,
  ListItem,
  ListItemText,
  Stack,
  TextField,
  Typography,
  CircularProgress
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";
import { useEffect, useLayoutEffect, useRef, useState, useCallback } from "react";
import { debounce } from "lodash";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import CloseIcon from "@mui/icons-material/Close";
import FmdGoodIcon from "@mui/icons-material/FmdGood";

import BuildIcon from "@mui/icons-material/Build";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import Grid from "@mui/material/Grid";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import {
  FETCH_COMPANIES,
  FETCH_COMPANIES_2,
  FETCH_COMPANIES_BY_NAME_NEW,
  FETCH_PRODUCTS,
  FETCH_PROJECT_COMPANY_ROLES,
  FETCH_ROLES,
  FETCH_SITES,
  FETCH_TICKETSBY_USERID,
  FETCH_TICKET_TYPES,
  FETCH_TRADES,
  FETCH_TRANSLATOR_LANGUAGES,
  FETCH_USER_REWARD_ACTIVITIES,
  FETCH_USER_SITES_PROJECTS,
  FETCH_SITES_PROJECTS,
  GET_BUILDING_TYPES,
  SAVE_COMPANIES,
  SAVE_PRODUCTS,
  SAVE_ROLE,
  SAVE_SITE_COMPANY,
  SAVE_USER_QUIZ_ANSWERS,
  SITE_DETAIL_TYPE,
  SEARCH_SITES
} from "../../constant/Apipath";



import { Postrequestcall } from "../../request/Postrequest";
import { Getrequestcall } from "../../request/Getrequest";
import { useDispatch } from "react-redux";
import {
  setPreviousQuestionId,
  setSelectedProjectdata,
  setChoosesite,
  setSelectlocation,
  setShowmapmodal,
  setSelectedsite,
  setShowaddproject,
  setSiteprojects
} from "../../redux/actions/actions";
import Removeduplicates from "../common/Removeduplicate";
import { getMenuCardBuilderBucks } from "../common/GetMenuCardBuilderBucks";
import { getAddress } from "../../request/Fetchcurrentaddress";
import Getcurrentlocation from "../common/Getcurrentlocation";
import { getFormattedAddress } from "../common/GetFormattedAddress";
import { BILightGrey } from "../../assets/helpers";
import { English } from "../../constant/EnglishFallback";
import ConstructionIcon from "@mui/icons-material/Construction";
import AddIcon from "@mui/icons-material/Add";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ApartmentIcon from "@mui/icons-material/Apartment";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import WarningIcon from "@mui/icons-material/Warning";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";

import AccordionDetails from "@mui/material/AccordionDetails";

import bucksIcon from "../../assets/images/bucks.png";
import AddTicket from "../tickets/AddTicket";
import SearchMap from "../sites/SearchMap";
import Addproject from "../common/Addproject";
import UseDebounce from "../common/UseDebounce";
import CompanySelectModal from "../common/CompanySelectModal";





let answersArray = [];
const filter = createFilterOptions();

const EarnBuilderBucksCard = (props) => {
  const {
    loginData,
    selectedProject,
    chooseSite,
    selectLocation,
    multiLanguageData,
    updateSiteprojects,
    showAddproject
  } = useSelector((state) => state?.main);

  const userId = loginData?.userInformation?.UserId;
  let dispatch = useDispatch();
  const navigate = useNavigate();
  const LanguageData = multiLanguageData?.RewardStore || {};

  const {
    TEXT_ASK_ME_LATER = English.RewardStore.TEXT_ASK_ME_LATER,
    TEXT_DONT_ASK_BTN = English.RewardStore.TEXT_DONT_ASK_BTN,
    TEXT_SUBMIT_BTN = English.RewardStore.TEXT_SUBMIT_BTN,
    TEXT_QUESTION_OF_THE_DAY = English.RewardStore.TEXT_QUESTION_OF_THE_DAY,
    TEXT_MONTH_YEAR = English.RewardStore.TEXT_MONTH_YEAR,
    TEXT_ANSWER = English.RewardStore.TEXT_ANSWER,
    TEXT_SEARCH_FOR = English.RewardStore.TEXT_SEARCH_FOR,
    TEXT_ADD = English.RewardStore.TEXT_ADD,
    TEXT_ADD_ANSWER = English.RewardStore.TEXT_ADD_ANSWER,
    TEXT_START_DATE = English.RewardStore.TEXT_START_DATE,
    TEXT_END_DATE = English.RewardStore.TEXT_END_DATE,
    TEXT_PRESENT = English.RewardStore.TEXT_PRESENT,
    TEXT_SELECT = English.RewardStore.TEXT_SELECT,
    TEXT_SELECT_UP_TO = English.RewardStore.TEXT_SELECT_UP_TO,
    TEXT_SELECT_ALL_THAT_APPLY = English.RewardStore.TEXT_SELECT_ALL_THAT_APPLY,
    TEXT_ADD_OPTIONS = English.RewardStore.TEXT_ADD_OPTIONS,
    TEXT_SEARCH_FOR_ADDRESS = English.RewardStore.TEXT_SEARCH_FOR_ADDRESS,
    TEXT_START_DATE_END_DATE_TITLE = English.RewardStore.TEXT_START_DATE_END_DATE_TITLE,
    TEXT_YOU_CAN_SELECT_UPTO = English.RewardStore.TEXT_YOU_CAN_SELECT_UPTO,
    TEXT_RESPONSES = English.RewardStore.TEXT_RESPONSES,
    TEXT_INDICATE_COMPANY_ROLE = English.RewardStore.TEXT_INDICATE_COMPANY_ROLE
  } = LanguageData || {};

  let isRoleIdAssigned = useRef(false);
  const [currentQuestionNr, setCurrentQueNr] = useState(0);
  const [optionText, setOptionText] = useState("");
  const [answer1, setAnswer1] = useState("");
  const [searchFields, setSearchFields] = useState([]);
  const [options, setOptions] = useState(props?.options ?? []);
  const [questionEntityName, setQuestionEntityName] = useState("");
  const [searchItem, setSearchItem] = useState("");
  const [otherCompanyRole, setOtherCompanyRole] = useState("");
  const [currentCompany, setCurrentCompany] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [isAddTextFieldVisible, setIsAddTextFieldVisible] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [endDate, setEndDate] = useState(null);
  const [flag, setFlag] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchPage, setSearchPage] = useState(1);
  const [searchHasMore, setSearchHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const [isClosing, setIsClosing] = useState(false);
  const [openPicker, setOpenPicker] = useState(null);
  const [formattedAddress, setFormattedAddress] = useState("");
  const [addressData, setAddressData] = useState({
    address: "",
    country: "",
    address1: "",
    province: "",
    city: "",
    postalCode: "",
    latitude: 0,
    longitude: 0
  });
  const [isLoading, setIsLoading] = useState(false);
  const [openTicketModal, setOpenTicketModal] = useState(false);
  const [showAddTicketModal, setShowAddTicketModal] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [ticketModalLoading, setTicketModalLoading] = useState(false);
  const [userTicketsList, setUserTicketsList] = useState([]);
  const [ticketSearchText, setTicketSearchText] = useState("");

  // Site List Modal State
  const [openSiteListModal, setOpenSiteListModal] = useState(false);
  const [siteList, setSiteList] = useState([]);
  const [siteListLoading, setSiteListLoading] = useState(false);
  const [siteSearchText, setSiteSearchText] = useState("");
  const [siteLocationText, setSiteLocationText] = useState("");
  const [siteCoords, setSiteCoords] = useState(null);
  const [totalSiteCount, setTotalSiteCount] = useState(0);

  // Project List Modal State
  const [openProjectListModal, setOpenProjectListModal] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [projectListLoading, setProjectListLoading] = useState(false);
  const [projectSearchText, setProjectSearchText] = useState("");
  const [projectActiveTab, setProjectActiveTab] = useState("allProjects"); // "bySite" | "allProjects"
  const [totalProjectCount, setTotalProjectCount] = useState(0);
  const [projectPage, setProjectPage] = useState(1);
  const [projectHasMore, setProjectHasMore] = useState(true);
  const [projectLoadingMore, setProjectLoadingMore] = useState(false);

  // By Site State in Project Modal
  const [bySiteList, setBySiteList] = useState([]);
  const [bySiteLoading, setBySiteLoading] = useState(false);
  const [bySiteSearchText, setBySiteSearchText] = useState("");
  const [bySiteLocationText, setBySiteLocationText] = useState("");
  const [bySiteCoords, setBySiteCoords] = useState(null);
  const [expandedSiteId, setExpandedSiteId] = useState(null);
  const [siteProjectsMap, setSiteProjectsMap] = useState({}); // { [siteId]: { projects: [], loading: false, count: 0 } }
  const [selectedSiteToAddProject, setSelectedSiteToAddProject] = useState(null);

  // Company / Manufacturer List Modal State
  const [openCompanyModal, setOpenCompanyModal] = useState(false);
  const [companyModalList, setCompanyModalList] = useState([]);
  const [companyModalLoading, setCompanyModalLoading] = useState(false);
  const [companyModalLoadingMore, setCompanyModalLoadingMore] = useState(false);
  const [companyModalSearchText, setCompanyModalSearchText] = useState("");
  const [companyModalPage, setCompanyModalPage] = useState(1);
  const [companyModalHasMore, setCompanyModalHasMore] = useState(true);

  // Debounced search terms (400ms)
  const debouncedSiteSearch = UseDebounce(siteSearchText, 400);
  const debouncedProjectSearch = UseDebounce(projectSearchText, 400);
  const debouncedBySiteSearch = UseDebounce(bySiteSearchText, 400);
  const debouncedCompanySearch = UseDebounce(companyModalSearchText, 400);

  useEffect(() => {
    if (openSiteListModal) {
      fetchSitesForModal(debouncedSiteSearch, siteCoords);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSiteSearch]);

  useEffect(() => {
    if (openProjectListModal && projectActiveTab === "allProjects") {
      fetchProjectsForModal(debouncedProjectSearch, 1, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedProjectSearch]);

  useEffect(() => {
    if (openCompanyModal) {
      fetchCompaniesForModal(debouncedCompanySearch, 1, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedCompanySearch]);

  useEffect(() => {
    if (updateSiteprojects === true) {
      dispatch(setSiteprojects(false));
      // Clear cached site projects map and re-fetch for expanded site
      if (expandedSiteId) {
        setSiteProjectsMap((prev) => ({
          ...prev,
          [expandedSiteId]: undefined
        }));
        fetchProjectsForSiteAccordion(expandedSiteId);
      }
      if (openProjectListModal) {
        if (projectActiveTab === "bySite") {
          fetchBySitesForModal("", bySiteCoords);
        } else {
          fetchProjectsForModal("", 1, false);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateSiteprojects]);








  useEffect(() => {
    if (props?.options?.length > 0) {
      setOptions(props?.options ?? []);
    }
    setAnswer1("");
  }, [props?.options?.length > 0]);

  useEffect(() => {
    if (currentCompany && startDate !== null) {
      setAnswer1("present");
    } else if (!currentCompany && startDate !== null && endDate !== null) {
      setAnswer1("range");
    } else {
      setAnswer1("");
    }
  }, [currentCompany, startDate, endDate]);

  useEffect(() => {
    if (selectLocation && (Number(selectLocation.lat) !== 0 || Number(selectLocation.lng) !== 0)) {
      if (selectLocation?.from === "site-list" || selectLocation?.from === "site-modal") {
        const lat = Number(selectLocation.lat);
        const lng = Number(selectLocation.lng);
        setSiteCoords({ lat, lng });
        setSiteSearchText("");
        (async () => {
          try {
            const addressObject = await getAddress({ lat, lng });
            const formatted = getFormattedAddress(
              addressObject?.objAddress?.address ?? "",
              addressObject?.objAddress?.address1 ?? "",
              addressObject?.objAddress?.city ?? "",
              addressObject?.objAddress?.province ?? "",
              addressObject?.objAddress?.country ?? "",
              addressObject?.objAddress?.postalCode ?? "",
              1
            );
            setSiteLocationText(formatted || `(${lat.toFixed(4)}, ${lng.toFixed(4)})`);
            fetchSitesForModal("", { lat, lng });
          } catch (e) {
            fetchSitesForModal("", { lat, lng });
          }
        })();
      } else {
        onGetAddress();
        setAnswer1("");
      }
    }
  }, [selectLocation]);



  const onGetAddress = async () => {
    try {


      let lat = Number(selectLocation.lat);
      let lng = Number(selectLocation.lng);
      const addressObject = await getAddress({ lat, lng });
      const newAddObj = {
        address: addressObject?.objAddress?.address,
        address1: addressObject?.objAddress?.address1,
        city: addressObject?.objAddress?.city,
        province: addressObject?.objAddress?.province,
        country: addressObject?.objAddress?.country,
        postalCode: addressObject?.objAddress?.postalCode,
        latitude: addressObject?.objAddress?.lat,
        longitude: addressObject?.objAddress?.lng
      };

      setAddressData(newAddObj);
      const userAddress = addressObject?.objAddress;
      let { city, country, province, postalCode, address, address1 } = userAddress ? userAddress : {};
      city =
        city !== "" && city
          ? city.replace(/\w*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
          : "";
      country =
        country !== "" && country
          ? country.replace(
            /\w*/g,
            (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
          )
          : "";

      const uAddress = getFormattedAddress(
        address ?? "",
        address1 ?? "",
        city ?? "",
        province ?? "",
        country ?? "",
        postalCode ?? "",
        1
      );
      setAnswer1(uAddress ?? "");
      setFormattedAddress(uAddress);
    } catch (error) {
      console.log('Something went wrong when getting location')
    }
  };

  const saveCompanyRole = async (itemId, companyRole, otherCompanyRole, key) => {
    if (companyRole.toLowerCase() === "other" && !otherCompanyRole.trim()) {
      alert(TEXT_INDICATE_COMPANY_ROLE);
      return;
    }

    const payload = {
      Id: 0,
      SiteId: Number(props?.question?.variableTypeBId ?? 0),
      CompanyId: Number(props?.question?.variableTypeAId ?? 0),
      CreatedBy: Number(userId),
      DateCreated: moment().format(),
      DateModified: moment().format(),
      ModifiedBy: Number(userId),
      SiteCompanyRoleId: itemId,
      OtherSiteCompanyRole: otherCompanyRole
    };

    try {
      const result = await Postrequestcall(SAVE_SITE_COMPANY, payload, loginData?.accessToken);
      const newRoleId = Number(result?.data);
      answersArray.push(newRoleId);

      if (key === 1) {
        setAnswer1(newRoleId);
        isRoleIdAssigned.current = true;
        handleAnswers(1);
      } else {
        const updatedFields = searchFields.filter(
          (field) =>
            field.name.toLowerCase() !== companyRole.toLowerCase() ||
            field.otherCompanyRole.toLowerCase() !== otherCompanyRole.toLowerCase()
        );
        setSearchFields(updatedFields);

        if (!updatedFields.length) handleAnswers(1);
      }
    } catch (error) {
      console.error("saveCompanyRole-> Error When Saving Site Company: ", error.message);
      setSearchFields([]);
    }
  };

  const saveSelectedItem = async (selectedItem, option) => {
    const userIdNumber = Number(userId);
    const timestamp = moment().format();
    const mainObj = {
      UserId: userIdNumber,
      ReturnRecordId: true,
      ReturnRecordError: true
    };
    const saveObject = {
      ...mainObj,
      SaveList: [
        {
          Id: 0,
          Name: selectedItem,
          ModifiedBy: userIdNumber,
          RecordStatusId: 1,
          Manufacturer: false
        }
      ]
    };

    try {
      let response;
      if (option === "Company") {
        response = await Postrequestcall(SAVE_COMPANIES, saveObject, loginData?.accessToken);
        let resCompany = response?.data?.data[0]?.objData?.id;
        return resCompany;
      }
      // else if (option === "Trade") {
      //   const formData = new FormData();
      //   formData.append("Id", 0);
      //   formData.append("Name", selectedItem);
      //   formData.append("TradePictureUrl", "");
      //   formData.append("Description", "");
      //   formData.append("ModifiedBy", loginData?.userInformation?.UserId);
      //   response = await Postrequestcall(SAVE_TRADES, formData, loginData?.accessToken);
      //   return response;
      // }
      else if (option === "Product") {
        const productObj = {
          ...mainObj,
          SaveList: [
            {
              Id: 0,
              Name: selectedItem,
              RecordStatusId: 1,
              ModifiedBy: userIdNumber
            }
          ]
        };
        response = await Postrequestcall(SAVE_PRODUCTS, productObj, loginData?.accessToken);
        let resProduct = response?.data?.data[0]?.objData?.id;
        return resProduct;
      } else if (option === "Title/Role" || option === `Company's Role` || option === "Role") {
        response = await Postrequestcall(
          SAVE_ROLE,
          {
            Id: 0,
            Name: selectedItem,
            ModifiedBy: userIdNumber,
            DateCreated: timestamp
          },
          loginData?.accessToken
        );
        let resRole = response?.data?.data;
        return resRole;
      }
    } catch (error) {
      console.error("saveSelectedItem-> Error When Saving Data: ", error);
    }
  };

  const getUserrewardActivities = async () => {
    try {
      const obj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: userId,
        IncludeRecordNr: "false",
        TypeOfObjectReturned: "",
        SearchList: [
          {
            RecordId: props.id,
            UserId: userId,
            ApplicationId: 6
          }
        ],
        SortList: [{}]
      };

      const getResponse = await Postrequestcall(
        FETCH_USER_REWARD_ACTIVITIES,
        obj,
        loginData?.accessToken
      );

      const getResponseData = getResponse?.data?.data;
      if (getResponseData?.length > 0) {
        props.setAnswercount(getResponseData[0]?.bucks);
      }
    } catch (error) {
      console.log("getUserrewardActivities-> Error While Fetching User Reward Activity: ", error);
    }
  };

  const getUpdatedCount = () => {
    dispatch(getMenuCardBuilderBucks(userId, loginData?.accessToken));
  };

  const handleAnswers = async (response) => {
    dispatch(setPreviousQuestionId(0));

    if (response === 1) {
      switch (props?.question?.quizType) {
        case "Search":
          if (props?.question?.responseType === "SiteCompanyRole" && !isRoleIdAssigned) {
            await saveCompanyRole(answer1, searchItem, otherCompanyRole, 1);
            return;
          }

          if (props?.question?.responseType === "SiteCompanyRole" && searchFields.length !== 0) {
            searchFields.map((data) =>
              saveCompanyRole(data.id, data.name, data.otherCompanyRole, 2)
            );
            return;
          } else if (props?.question?.response_EntityName == "Project") {
            answersArray.push(selectedProject?.projectId);
          } else if (props?.question?.response_EntityName?.trim() == "Site") {
            answersArray.push(chooseSite?.id);
          } else if (
            props?.question?.responseType !== "SiteCompanyRole" ||
            props?.question?.response_EntityName !== "Trade"
          ) {
            if (answer1 == 0 && questionEntityName !== "") {
              let getCompanyId = await saveSelectedItem(
                questionEntityName,
                props?.question?.response_EntityName
              );
              answersArray.push(getCompanyId);
            } else if (props?.question?.response_EntityName == "Trade") {
              answersArray.push(answer1);
            } else {
              answersArray.push(answer1);
            }
          }
          break;
        case "Date":
          let selectedDate = dayjs(startDate).startOf("month"); // Using Day.js
          let formattedStartDate = selectedDate.format("YYYY-MM-DD");

          let selectedEndDate = dayjs(endDate).startOf("month"); // Using Day.js
          let formattedEndDate = selectedEndDate.format("YYYY-MM-DD");

          if (
            props?.question?.minResponses !== 1 &&
            !currentCompany &&
            formattedStartDate > formattedEndDate
          ) {
            alert(TEXT_START_DATE_END_DATE_TITLE);
            return;
          }
          break;
        case "Multiline":
          answersArray.push(answer1);
          break;
        case "Address":
          const addArray = {
            address: addressData.address,
            address1: addressData.address1,
            city: addressData.city,
            country: addressData.country,
            province: addressData.province,
            postalCode: addressData.postalCode,
            latitude: addressData.latitude,
            longitude: addressData.longitude
          };
          answersArray.push(addArray);
          break;
        case "Number":
          answersArray.push(answer1);
          break;
        case "Select":
          const selectedOptions = options.filter((op) => op.isSelected);
          if (selectedOptions.length > props?.question?.maxResponses) {
            alert(`${TEXT_YOU_CAN_SELECT_UPTO} ${props?.question?.maxResponses} ${TEXT_RESPONSES}`);
            return;
          }
          selectedOptions.map((op) => answersArray.push(op.optionName));
          break;
        default:
          return;
      }
    }
    try {
      setIsLoading(true);
      if (response === 1) {
        await saveAnswers();

      } else if (response == 2) {
        const obj2 = {
          UserId: Number(userId),
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: [
            {
              UserId: Number(userId),
              UserQuizId: props?.prevQueId,
              AnswerTypeId: 2,
              Answer: "",
              Answer1: "",
              Answer2: "",
              Answer3: "",
              Answer4: "",
              Answer5: "",
              Answer6: "",
              Answer7: "",
              Answer8: "",
              Answer9: ""
            }
          ]
        };
        await Postrequestcall(SAVE_USER_QUIZ_ANSWERS, obj2, loginData?.accessToken);
      } else if (response == 3) {
        const obj2 = {
          UserId: Number(userId),
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: [
            {
              UserId: Number(userId),
              UserQuizId: props?.prevQueId,
              AnswerTypeId: 3,
              Answer: "",
              Answer1: "",
              Answer2: "",
              Answer3: "",
              Answer4: "",
              Answer5: "",
              Answer6: "",
              Answer7: "",
              Answer8: "",
              Answer9: ""
            }
          ]
        };
        await Postrequestcall(SAVE_USER_QUIZ_ANSWERS, obj2, loginData?.accessToken);
      }
      answersArray = [];
      setAnswer1("");
      setSearchItem("");
      setOtherCompanyRole("");
      setSearchFields([]);
      setAddressData({
        address: "",
        address1: "",
        city: "",
        province: "",
        country: "",
        postalCode: "",
        latitude: 0,
        longitude: 0
      });
      setFormattedAddress("");
      setCurrentQueNr(currentQuestionNr + 1);
      setStartDate(null);
      setEndDate(null);
      setOptions([]);
      setSelectedTicket(null);
      setOptionText("");
      setOptionText("");

      dispatch(setSelectedProjectdata(null));
      dispatch(setChoosesite(null));
      dispatch(
        setSelectlocation({
          open: false,
          lat: 0,
          lng: 0
        })
      );
      isRoleIdAssigned.current = false;
      props?.setLoadingData(false);
      if (props?.from === "dashboard" || props?.from === "new-dashboard") {
        props?.setVisibleQuestions();
        return;
      }
      await props.getQuestions();
    } catch (error) {
      console.log("handleAnswers-> Error While Saving User Answer: ", error);
      alert(error.message);
    }
    setIsLoading(false);
  };

  const saveAnswers = async () => {
    try {
      if (props?.question?.quizType === "Address") {
        const obj2 = {
          UserId: Number(loginData?.userInformation?.UserId),
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: [
            {
              UserId: Number(loginData?.userInformation?.UserId),
              UserQuizId: props?.prevQueId,
              AnswerTypeId: 1,
              Answer: addressData.address ?? "",
              Answer1: addressData.address1 ?? "",
              Answer2: addressData.city ?? "",
              Answer3: addressData.province ?? "",
              Answer4: addressData.country ?? "",
              Answer5: addressData.postalCode ?? "",
              Answer6: addressData.latitude ?? "",
              Answer7: addressData.longitude ?? "",
              Answer8: "",
              Answer9: ""
            }
          ]
        };

        await Postrequestcall(SAVE_USER_QUIZ_ANSWERS, obj2, loginData?.accessToken);
      } else if (props?.question?.quizType == "Date") {
        const selectedDate = dayjs(startDate).startOf("month"); // Using Day.js
        const formattedStartDate = selectedDate.format("YYYY-MM-DD");

        const selectedEndDate = dayjs(endDate).startOf("month"); // Using Day.js
        const formattedEndDate = selectedEndDate.format("YYYY-MM-DD");

        const obj2 = {
          UserId: Number(loginData?.userInformation?.UserId),
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: [
            {
              UserId: Number(loginData?.userInformation?.UserId),
              UserQuizId: props?.prevQueId,
              AnswerTypeId: 1,
              Answer: moment(formattedStartDate).format("YYYY-MM-DD") ?? "",
              Answer1:
                endDate !== null
                  ? moment(formattedEndDate).format("YYYY-MM-DD")
                  : currentCompany
                    ? ""
                    : "",
              Answer2: "",
              Answer3: "",
              Answer4: "",
              Answer5: "",
              Answer6: "",
              Answer7: "",
              Answer8: "",
              Answer9: ""
            }
          ]
        };
        await Postrequestcall(SAVE_USER_QUIZ_ANSWERS, obj2, loginData?.accessToken);
      }
      // else if (props?.question?.response_EntityName === "Company") {
      //   // await updateCompanyData();
      // }
      else if (props?.question?.canAddResponse) {
        const obj2 = {
          UserId: Number(loginData?.userInformation?.UserId),
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: [
            {
              UserId: Number(loginData?.userInformation?.UserId),
              UserQuizId: props?.prevQueId,
              AnswerTypeId: 1,
              Answer: "",
              Answer1: "",
              Answer2: "",
              Answer3: "",
              Answer4: "",
              Answer5: "",
              Answer6: "",
              Answer7: "",
              Answer8: "",
              Answer9: ""
            }
          ]
        };

        let userObjectCopy = { ...obj2 };
        answersArray?.forEach((answer, index) => {
          if (index === 0) {
            userObjectCopy.SaveList[0].Answer = answer?.toString();
          } else if (index >= 1 && index <= 8) {
            userObjectCopy.SaveList[0][`Answer${index}`] = answer.toString();
          }
        });
        await Postrequestcall(SAVE_USER_QUIZ_ANSWERS, obj2, loginData?.accessToken);
      } else {
        const ans = answersArray
          ?.map((ans) => {
            return ans;
          })
          ?.pop();
        const obj2 = {
          UserId: Number(loginData?.userInformation?.UserId),
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: [
            {
              UserId: Number(loginData?.userInformation?.UserId),
              UserQuizId: props?.prevQueId,
              AnswerTypeId: 1,
              Answer: typeof ans == "number" ? `${ans}` : ans,
              Answer1: "",
              Answer2: "",
              Answer3: "",
              Answer4: "",
              Answer5: "",
              Answer6: "",
              Answer7: "",
              Answer8: "",
              Answer9: ""
            }
          ]
        };
        await Postrequestcall(SAVE_USER_QUIZ_ANSWERS, obj2, loginData?.accessToken);
      }
      getUpdatedCount();
      answersArray = [];
      setAnswer1("");
      setSearchItem("");
      setOtherCompanyRole("");
      setSearchFields([]);
      setAddressData({
        address: "",
        address1: "",
        city: "",
        province: "",
        country: "",
        postalCode: "",
        latitude: 0,
        longitude: 0
      });
      setCurrentQueNr(currentQuestionNr + 1);
      setStartDate(null);
      setEndDate(null);
      setOptions([]);
      setSelectedTicket(null);
      setOptionText("");
      setOptionText("");
      isRoleIdAssigned.current = false;
      if (props?.from === "dashboard" || props?.from === "new-dashboard") {
        await getUserrewardActivities();
        props?.setVisibleQuestions();
        return;
      }

      await props.getQuestions();
      props?.setLoadingData(false);
    } catch (error) {
      props?.setLoadingData(false);
      dispatch(setSelectedProjectdata(null));
      dispatch(setChoosesite(null));
      dispatch(
        setSelectlocation({
          open: false,
          lat: 0,
          lng: 0
        })
      );
      console.log("saveAnswers-> Error When Trying To Save Answer: ", error);
    }
  };

  const getFilterQuestionData = async (searchText, pageNum = 1) => {
    if (searchText !== "" && searchText?.length > 1) {
      if (pageNum === 1) {
        setIsSearching(true);
        isSearchingRef.current = true;
        setSearchHasMore(true);
        searchHasMoreRef.current = true;
        setSearchPage(1);
        searchPageRef.current = 1;
      } else {
        setLoadingMore(true);
        loadingMoreRef.current = true;
      }
      try {
        const object = {
          PageNr: pageNum,
          FullSearch: "",
          SearchList: [
            {
              Name: searchText,
              Manufacturer:
                props?.question?.response_EntityName?.toLowerCase() == "manufacturer" ? true : false
            }
          ],
          SortList: [{ FieldName: "Name", Direction: "ASC" }],
          IncludeRecordNr: false,
          TypeOfObjectReturned: "NameOnly"
        };
        const productObj = {
          PageNr: pageNum,
          NrOfRecPerPage: 20,
          FullSearch: "",
          UserId: userId,
          IncludeRecordNr: false,
          TypeOfObjectReturned: "",
          FetchAllowedRecordsOnly: true,
          SearchList: [
            {
              Name: searchText
            }
          ],
          SortList: [{ FieldName: "Name", Direction: "ASC" }]
        };
        const companyRoleObj = {
          PageNr: pageNum,
          NrOfRecPerPage: 20,
          FullSearch: "",
          UserId: userId,
          IncludeRecordNr: true,
          TypeOfObjectReturned: "",
          FetchAllowedRecordsOnly: true,
          SearchList: [{ Name: searchText }],
          SortList: [{ FieldName: "Name", Direction: "ASC" }]
        };

        if (props?.question?.response_EntityName?.trim()?.toLowerCase() === "company") {
          // OLD API: FETCH_COMPANIES (commented, do not delete)
          // const responses = await Postrequestcall(FETCH_COMPANIES, object, loginData?.accessToken);

          const companyObj = {
            PageNr: pageNum,
            NrOfRecPerPage: 20,
            FullSearch: searchText,
            UserId: userId,
            IncludeRecordNr: "true",
            TypeOfObjectReturned: "",
            FetchAllowedRecordsOnly: true,
            SearchList: [{}],
            SortList: [
              { FieldName: "Verified", Direction: "DESC" },
              { FieldName: "Name", Direction: "ASC" }
            ]
          };
          const responses = await Postrequestcall(FETCH_COMPANIES_BY_NAME_NEW, companyObj, loginData?.accessToken);


          if (responses) {
            let companyRes = [];
            if (responses?.data?.data) {
              companyRes = responses?.data
            } else {
              if (pageNum === 1) {
                setFilterData([]);
              }
              setSearchHasMore(false);
              searchHasMoreRef.current = false;
              return
            }

            let a;
            companyRes?.data?.map((x) => {
              a = x;
              a["title"] = x?.name;
              return a;
            });
            const response = Removeduplicates(companyRes?.data, "name");
            if (pageNum === 1) {
              setFilterData(response);
            } else {
              setFilterData((prev) => {
                const merged = [...prev, ...response];
                return Removeduplicates(merged, "name");
              });
            }
            if ((companyRes?.data?.length || 0) < 20) {
              setSearchHasMore(false);
              searchHasMoreRef.current = false;
            } else {
              setSearchPage(pageNum);
              searchPageRef.current = pageNum;
            }
          }
        } else if (props?.question?.response_EntityName === "Product") {
          const responses = await Postrequestcall(FETCH_PRODUCTS, productObj, loginData?.accessToken);
          const productRes = responses?.data;

          let a;
          productRes?.data?.map((x) => {
            a = x;
            a["title"] = x?.name;
            return a;
          });
          const response = await Removeduplicates(productRes?.data, "name");
          if (pageNum === 1) {
            setFilterData(response);
          } else {
            setFilterData((prev) => {
              const merged = [...prev, ...response];
              return Removeduplicates(merged, "name");
            });
          }
          if (productRes?.data?.length < 20) {
            setSearchHasMore(false);
          } else {
            setSearchPage(pageNum);
          }
        } else if (
          props?.question?.response_EntityName?.toLowerCase() == "role/title" ||
          props?.question?.response_EntityName?.toLowerCase() == "role" ||
          props?.question?.response_EntityName?.toLowerCase() == "title/role"
        ) {
          const responses = await Postrequestcall(FETCH_ROLES, object, loginData?.accessToken);
          const roleRes = responses?.data;

          let a;
          roleRes?.data?.map((x) => {
            a = x;
            a["title"] = x?.name;
            return a;
          });
          const response = await Removeduplicates(roleRes?.data, "name");
          if (pageNum === 1) {
            setFilterData(response);
          } else {
            setFilterData((prev) => {
              const merged = [...prev, ...response];
              return Removeduplicates(merged, "name");
            });
          }
          if (roleRes?.data?.length < 20) {
            setSearchHasMore(false);
          } else {
            setSearchPage(pageNum);
          }
        } else if (props?.question?.response_EntityName?.toLowerCase() == "trade") {
          const responses = await Postrequestcall(FETCH_TRADES, object, loginData?.accessToken);
          const tradeRes = responses?.data;
          let a;
          tradeRes?.data?.map((x) => {
            a = x;
            a["title"] = x?.name;
            return a;
          });
          const response = await Removeduplicates(tradeRes?.data, "name");
          if (pageNum === 1) {
            setFilterData(response);
          } else {
            setFilterData((prev) => {
              const merged = [...prev, ...response];
              return Removeduplicates(merged, "name");
            });
          }
          if (tradeRes?.data?.length < 20) {
            setSearchHasMore(false);
          } else {
            setSearchPage(pageNum);
          }
        } else if (props?.question?.response_EntityName?.toLowerCase() == "project") {
          const projectObj = {
            PageNr: pageNum,
            FullSearch: "",
            SearchList: [
              {
                ProjectName: searchText,
                Manufacturer:
                  props?.question?.response_EntityName?.toLowerCase() == "manufacturer" ? true : false
              }
            ],
            IncludeRecordNr: false,
            NrOfRecPerPage: 20,
            FetchAllowedRecordsOnly: true
          };
          const responses = await Postrequestcall(
            FETCH_USER_SITES_PROJECTS,
            projectObj,
            loginData?.accessToken
          );
          const projectRes = responses?.data;

          let a;
          projectRes?.map((x) => {
            a = x;
            a["title"] = x?.projectName;
            return a;
          });
          const response = await Removeduplicates(projectRes, "projectName");
          if (pageNum === 1) {
            setFilterData(response);
          } else {
            setFilterData((prev) => {
              const merged = [...prev, ...response];
              return Removeduplicates(merged, "projectName");
            });
          }
          if (projectRes?.length < 20) {
            setSearchHasMore(false);
          } else {
            setSearchPage(pageNum);
          }
        } else if (props?.question?.response_EntityName?.toLowerCase() == "ticket type") {
          const responses = await Postrequestcall(FETCH_TICKET_TYPES, object, loginData?.accessToken);
          const ticketRes = responses?.data;

          setFilterData(ticketRes);
          setSearchHasMore(false);
        } else if (props?.question?.response_EntityName?.trim()?.toLowerCase() === "manufacturer") {
          // OLD API: FETCH_COMPANIES (commented, do not delete)
          // const responses = await Postrequestcall(FETCH_COMPANIES, object, loginData?.accessToken);

          // NEW API: FETCH_COMPANIES_BY_NAME (active)
          const manufacturerObj = {
            PageNr: pageNum,
            NrOfRecPerPage: 20,
            FullSearch: searchText,
            UserId: userId,
            IncludeRecordNr: "true",
            TypeOfObjectReturned: "",
            FetchAllowedRecordsOnly: true,
            SearchList: [{ manufacturer: true }],
            SortList: [
              { FieldName: "Verified", Direction: "DESC" },
              { FieldName: "Name", Direction: "ASC" }
            ]
          };
          const responses = await Postrequestcall(FETCH_COMPANIES_BY_NAME_NEW, manufacturerObj, loginData?.accessToken);
          if (responses) {
            let manufacturerRes = [];
            if (responses?.data?.data) {
              manufacturerRes = responses?.data
            } else {
              if (pageNum === 1) {
                setFilterData([]);
              }
              setSearchHasMore(false);
              searchHasMoreRef.current = false;
              return
            }

            let a;
            manufacturerRes?.data?.map((x) => {
              a = x;
              a["title"] = x?.name;
              return a;
            });
            const response = Removeduplicates(manufacturerRes?.data, "name");
            if (pageNum === 1) {
              setFilterData(response);
            } else {
              setFilterData((prev) => {
                const merged = [...prev, ...response];
                return Removeduplicates(merged, "name");
              });
            }
            if ((manufacturerRes?.data?.length || 0) < 20) {
              setSearchHasMore(false);
              searchHasMoreRef.current = false;
            } else {
              setSearchPage(pageNum);
              searchPageRef.current = pageNum;
            }
          }
        } else if (props?.question?.response_EntityName === "Site") {
          const responses = await Postrequestcall(FETCH_SITES, object, loginData?.accessToken);
          const siteRes = responses?.data;

          let a;
          siteRes?.data?.map((x) => {
            a = x;
            a["title"] = x?.name;
            return a;
          });
          const response = await Removeduplicates(siteRes?.data, "name");
          if (pageNum === 1) {
            setFilterData(response);
          } else {
            setFilterData((prev) => {
              const merged = [...prev, ...response];
              return Removeduplicates(merged, "name");
            });
          }
          if (siteRes?.data?.length < 20) {
            setSearchHasMore(false);
          } else {
            setSearchPage(pageNum);
          }
        } else if (props?.question?.response_EntityName?.toLowerCase() == "site type") {
          const responses = await Getrequestcall(GET_BUILDING_TYPES, object, loginData?.accessToken);
          const siteTypeRes = responses?.data;

          setFilterData(siteTypeRes);
          setSearchHasMore(false);
        } else if (props?.question?.response_EntityName?.toLowerCase() === "language") {
          const langObj = {
            Id: 0,
            PageNr: pageNum,
            NrOfRecPerPage: 200,
            FullSearch: searchText?.trim() || "",
            UserId: Number(userId),
            SearchList: [
              {
                isLanguageUsed: true
              }
            ],
            SortList: [
              {
                fieldName: "id",
                direction: ""
              }
            ],
            IncludeRecordNr: true,
            FetchAllowedRecordsOnly: true,
            DoNotShowInSystemFields: false
          };
          const responses = await Postrequestcall(
            FETCH_TRANSLATOR_LANGUAGES,
            langObj,
            loginData?.accessToken
          );
          const langList = responses?.data?.data || [];
          let formattedLangs = langList.map((x) => ({
            ...x,
            id: x?.id ?? x?.code ?? x?.language,
            title: x?.language || x?.name || x?.title
          }));



          if (searchText?.trim()) {
            formattedLangs = formattedLangs.filter((l) =>
              l.title?.toLowerCase().includes(searchText.toLowerCase())
            );
          }

          const response = await Removeduplicates(formattedLangs, "title");
          if (pageNum === 1) {
            setFilterData(response);
          } else {
            setFilterData((prev) => {
              const merged = [...prev, ...response];
              return Removeduplicates(merged, "title");
            });
          }
          setSearchHasMore(false);
        } else if (props?.question?.response_EntityName?.toLowerCase() === "ticket" || props?.question?.response_EntityName?.toLowerCase() === "tickets" ) {
          const ticketObj = {
            UserId: Number(userId),
            PageNo: pageNum,
            PageSize: 20,
            SearchString: searchText || ""
          };
          const responses = await Postrequestcall(
            FETCH_TICKETSBY_USERID,
            ticketObj,
            loginData?.accessToken
          );
          const userTickets = responses?.data?.data || [];
          let formattedTickets = userTickets.map((x) => ({
            ...x,
            id: x?.id || x?.ticketId || x?.ticketTypeId,
            title: x?.ticketName || x?.ticketTypeName || x?.name || x?.title
          }));

          const response = await Removeduplicates(formattedTickets, "title");
          if (pageNum === 1) {
            setFilterData(response);
          } else {
            setFilterData((prev) => {
              const merged = [...prev, ...response];
              return Removeduplicates(merged, "title");
            });
          }
          if (userTickets.length < 20) {
            setSearchHasMore(false);
          } else {
            setSearchPage(pageNum);
          }
        } else if (
          props?.question?.response_EntityName == "CompanyRole" ||
          props?.question?.response_EntityName == "ProjectCompanyRole" ||
          props?.question?.response_EntityName == `Company's Role`
        ) {
          const responses = await Postrequestcall(
            FETCH_PROJECT_COMPANY_ROLES,
            companyRoleObj,
            loginData?.accessToken
          );
          const projectCompanyRolesRes = responses?.data?.data;
          let a;
          projectCompanyRolesRes.map((x) => {
            a = x;
            a["title"] = x?.name;
            return a;
          });
          if (pageNum === 1) {
            setFilterData(projectCompanyRolesRes);
          } else {
            setFilterData((prev) => {
              const merged = [...prev, ...projectCompanyRolesRes];
              return Removeduplicates(merged, "name");
            });
          }
          if (projectCompanyRolesRes?.length < 20) {
            setSearchHasMore(false);
          } else {
            setSearchPage(pageNum);
          }
        }
      } catch (error) {
        console.error("Error fetching question data:", error);
      } finally {
        setIsSearching(false);
        isSearchingRef.current = false;
        setLoadingMore(false);
        loadingMoreRef.current = false;
      }
    } else {
      setIsSearching(false);
      isSearchingRef.current = false;
      setLoadingMore(false);
      loadingMoreRef.current = false;
    }
  };

  const getFilterQuestionDataRef = useRef();
  getFilterQuestionDataRef.current = getFilterQuestionData;

  const searchPageRef = useRef(1);
  searchPageRef.current = searchPage;

  const searchHasMoreRef = useRef(true);
  searchHasMoreRef.current = searchHasMore;

  const isSearchingRef = useRef(false);
  isSearchingRef.current = isSearching;

  const loadingMoreRef = useRef(false);
  loadingMoreRef.current = loadingMore;

  const questionEntityNameRef = useRef("");
  questionEntityNameRef.current = questionEntityName;

  const listboxNodeRef = useRef(null);
  const listboxScrollTopRef = useRef(0);

  useLayoutEffect(() => {
    if (listboxNodeRef.current && listboxScrollTopRef.current > 0) {
      listboxNodeRef.current.scrollTop = listboxScrollTopRef.current;
    }
  }, [filterData]);

  useEffect(() => {
    if (listboxNodeRef.current && listboxScrollTopRef.current > 0) {
      requestAnimationFrame(() => {
        if (listboxNodeRef.current) {
          listboxNodeRef.current.scrollTop = listboxScrollTopRef.current;
        }
      });
    }
  }, [filterData]);

  const debouncedGetFilterQuestionData = useCallback(
    debounce((searchText) => {
      getFilterQuestionDataRef.current?.(searchText);
    }, 400),
    []
  );

  const onSubmitOption = (index) => {
    if (optionText !== "" && isClosing) {
      const newOptions = options.filter((op, i) => {
        if (i === index) {
          op.isTextField = false;
          op.optionName = optionText;
        }
        return op;
      });
      setOptions(newOptions);
      setOptionText("");
      setIsAddTextFieldVisible(false);
      setIsClosing(false);
      setAnswer1(newOptions.length > 0 ? "Add" : "");
    } else {
      const newOptions = options.filter((item, i) => i !== index);
      setOptions(newOptions);
      setOptionText("");
      setIsAddTextFieldVisible(false);
    }
  };

  const onCloseOption = (e, index) => {
    e.stopPropagation();
    setOptions((prevOptions) => prevOptions.filter((_, i) => i !== index));
    resetOptionState();
  };

  const onAddAnswerPressed = () => {
    setSearchFields((prevFields) => [
      ...prevFields,
      {
        name: "",
        id: 0,
        roleId: 0,
        manufacturerId: 0,
        manufacturerName: "",
        otherCompanyRole: "",
        isTextField: true
      }
    ]);
  };

  const onAddOptionPressed = () => {
    setIsClosing(true);
    setOptions((prevOptions) => [
      ...prevOptions,
      { isSelected: false, optionName: "", isTextField: true }
    ]);
    setIsAddTextFieldVisible(true);
  };

  const onOptionSelected = (index) => {
    const max = props?.question?.maxResponses || 1;
    const updatedOptions = [...options];
    const optionToToggle = updatedOptions[index];

    // Create a new selected options array (avoid mutation)
    let newSelectedOptions = [...selectedOptions];

    if (optionToToggle.isSelected) {
      // Deselect if already selected
      optionToToggle.isSelected = false;
      newSelectedOptions = newSelectedOptions.filter(
        (op) => op !== optionToToggle // Compare by reference
      );
    } else {
      // If selecting a new option...
      if (newSelectedOptions.length >= max) {
        // Remove the oldest selected option (FIFO)
        const oldestOption = newSelectedOptions.shift(); // Remove first element
        const oldestIndex = updatedOptions.findIndex(
          (op) => op === oldestOption // Compare by reference
        );
        if (oldestIndex !== -1) {
          updatedOptions[oldestIndex].isSelected = false;
        }
      }

      // Select the new option
      optionToToggle.isSelected = true;
      newSelectedOptions.push(optionToToggle);
    }

    // Update state
    setOptions(updatedOptions);
    setSelectedOptions(newSelectedOptions);
    setAnswer1(newSelectedOptions.length > 0 ? "Add" : "");
  };

  const handleDateChange = (newValue, picker) => {
    if (picker === "start") {
      if (newValue && newValue.$y) {
        setStartDate(newValue); // Only set when a valid date is selected
      }
    } else if (picker === "end") {
      if (newValue && newValue.$y) {
        setEndDate(newValue);
        setAnswer1(startDate == null ? "" : newValue);
      }
    }
  };

  const handlePickerClose = (picker) => {
    setOpenPicker(null);
    setTimeout(() => {
      if (picker === "start" && !startDate) {
        setStartDate(null); // Reset value if no valid selection is made
      }
      if (picker === "end" && !endDate) {
        setEndDate(null);
      }
      setOpenPicker(null);
    }, 100);
  };

  const handleTogglePicker = (e, picker) => {
    e.stopPropagation();
    e.preventDefault();
    if (picker === "end" && currentCompany) {
      setOpenPicker(null);
    } else {
      setOpenPicker((prev) => (prev === picker ? null : picker)); // Toggle between pickers
    }
  };

  const handleClear = (e, picker) => {
    setOpenPicker(null);
    e.preventDefault();
    e.stopPropagation();
    if (picker === "start") setStartDate(null);
    if (picker === "end") setEndDate(null);
  };

  const onPresentChange = (event) => {
    setCurrentCompany(event.target.checked);
    setEndDate(null);
    setAnswer1(startDate !== null && !currentCompany ? moment() : "");
  };

  // Site List Functions
  const fetchSitesForModal = async (search = "", coords = siteCoords) => {
    setSiteListLoading(true);
    try {
      if (search?.trim()) {
        const payload = {
          Name: search.trim()
        };
        const response = await Postrequestcall(SEARCH_SITES, payload, loginData?.accessToken);
        if (response?.status === 200) {
          const sites = response?.data?.data || response?.data || [];
          const siteArr = Array.isArray(sites) ? sites : [];
          setSiteList(siteArr);
          setTotalSiteCount(response?.data?.nrOfRecords || siteArr.length);
        } else {
          setSiteList([]);
          setTotalSiteCount(0);
        }
      } else {
        let lat = coords?.lat;
        let lng = coords?.lng;
        if (!lat || !lng) {
          const loc = await Getcurrentlocation(multiLanguageData);
          lat = loc?.lat;
          lng = loc?.lng;
          setSiteCoords({ lat, lng });
          const addr = await getAddress({ lat, lng });
          const formatted = getFormattedAddress(
            addr?.objAddress?.address ?? "",
            addr?.objAddress?.address1 ?? "",
            addr?.objAddress?.city ?? "",
            addr?.objAddress?.province ?? "",
            addr?.objAddress?.country ?? "",
            addr?.objAddress?.postalCode ?? "",
            1
          );
          setSiteLocationText(formatted || "Current Location");
        }

        const latDelta = 0.007; // ~750m viewport span
        const lngDelta = 0.014;

        const payload = {
          Active: 0,
          latitude: lat,
          longitude: lng,
          VP_Latitude_NE: lat + latDelta,
          VP_Latitude_SW: lat - latDelta,
          VP_Longitude_NE: lng + lngDelta,
          VP_Longitude_SW: lng - lngDelta,
          UserId: Number(userId),
          Filters: 0,
          FetchAllowedRecordsOnly: true
        };

        const response = await Postrequestcall(SITE_DETAIL_TYPE, payload, loginData?.accessToken);

        if (response?.status === 200) {
          const sites = response?.data?.data || [];
          setSiteList(sites);
          setTotalSiteCount(response?.data?.nrOfRecords || sites.length);
        } else {
          setSiteList([]);
          setTotalSiteCount(0);
        }
      }
    } catch (error) {
      console.error("fetchSitesForModal error:", error);
      setSiteList([]);
      setTotalSiteCount(0);
    } finally {
      setSiteListLoading(false);
    }
  };

  const onChooseSitePressed = () => {
    setSiteSearchText("");
    setSiteCoords(null);
    setSiteLocationText("");
    fetchSitesForModal("", null);
    setOpenSiteListModal(true);
  };

  const handleSelectSiteFromModal = (site) => {
    dispatch(setSelectedsite(site));
    dispatch(setChoosesite(site));
    const siteName = site?.name || site?.siteName || "Unnamed Site";
    setQuestionEntityName(siteName);
    setAnswer1(site?.id);
    setOpenSiteListModal(false);
  };

  // Company / Manufacturer List Modal Functions (with Infinite Scroll)
  const COMPANY_PAGE_SIZE = 20;

  const fetchCompaniesForModal = async (search = "", page = 1, isLoadMore = false) => {
    const isManufacturer =
      props?.question?.response_EntityName?.trim()?.toLowerCase() === "manufacturer";
    if (isLoadMore) {
      setCompanyModalLoadingMore(true);
    } else {
      setCompanyModalLoading(true);
    }
    try {
      const payload = {
        PageNr: page,
        NrOfRecPerPage: COMPANY_PAGE_SIZE,
        FullSearch: search?.trim() || "",
        UserId: userId,
        IncludeRecordNr: true,
        TypeOfObjectReturned: "",
        FetchAllowedRecordsOnly: true,
        SearchList: [isManufacturer ? { manufacturer: true } : {}],
        SortList: [
          { FieldName: "Verified", Direction: "DESC" },
          { FieldName: "Name", Direction: "ASC" }
        ]
      };
      const response = await Postrequestcall(FETCH_COMPANIES_BY_NAME_NEW, payload, loginData?.accessToken);
      if (response?.data?.data) {
        const items = response.data.data;
        if (page === 1) {
          setCompanyModalList(items);
        } else {
          setCompanyModalList((prev) => Removeduplicates([...prev, ...items], "name"));
        }
        setCompanyModalPage(page);
        setCompanyModalHasMore(items.length >= COMPANY_PAGE_SIZE);
      } else {
        if (page === 1) setCompanyModalList([]);
        setCompanyModalHasMore(false);
      }
    } catch (error) {
      console.error("fetchCompaniesForModal error:", error);
    } finally {
      setCompanyModalLoading(false);
      setCompanyModalLoadingMore(false);
    }
  };

  const onChooseCompanyPressed = () => {
    setCompanyModalSearchText("");
    setCompanyModalList([]);
    setCompanyModalPage(1);
    setCompanyModalHasMore(true);
    fetchCompaniesForModal("", 1, false);
    setOpenCompanyModal(true);
  };

  const handleSelectCompanyFromModal = (company) => {
    if (company?.recordStatusId === 3) {
      alert("This company is reported");
      return;
    }
    setQuestionEntityName(company?.name || "");
    setAnswer1(company?.id);
    setOpenCompanyModal(false);
  };

  // Project List Functions (All Projects with Infinite Scroll)
  const PROJECT_PAGE_SIZE = 20;

  const fetchProjectsForModal = async (search = "", page = 1, isLoadMore = false) => {
    if (isLoadMore) {
      setProjectLoadingMore(true);
    } else {
      setProjectListLoading(true);
    }
    try {
      const payload = {
        PageNr: page,
        FullSearch: search?.trim() || "",
        SearchList: [
          {
            ProjectName: search?.trim() || "",
            Manufacturer: false
          }
        ],
        IncludeRecordNr: true,
        NrOfRecPerPage: PROJECT_PAGE_SIZE,
        FetchAllowedRecordsOnly: true
      };
      const response = await Postrequestcall(FETCH_USER_SITES_PROJECTS, payload, loginData?.accessToken);
      if (response?.status === 200) {
        let projects = response?.data?.data || response?.data || [];
        const total = response?.data?.recordsNr || response?.data?.nrOfRecords || projects.length;
        setTotalProjectCount(total);
        if (page === 1) {
          setProjectList(projects);
        } else {
          setProjectList((prev) => {
            const merged = [...prev, ...projects];
            return Removeduplicates(merged, "id");
          });
        }
        setProjectPage(page);
        setProjectHasMore(projects.length >= PROJECT_PAGE_SIZE);
      }
    } catch (error) {
      console.error("fetchProjectsForModal error:", error);
    } finally {
      setProjectListLoading(false);
      setProjectLoadingMore(false);
    }
  };

  // By Site Functions (Accordion list of sites with Google Places Autocomplete)
  const fetchBySitesForModal = async (search = "", customCoords = bySiteCoords) => {
    setBySiteLoading(true);
    try {
      let lat = customCoords?.lat;
      let lng = customCoords?.lng;

      if (!lat || !lng) {
        const loc = await Getcurrentlocation(multiLanguageData);
        lat = loc?.lat;
        lng = loc?.lng;
        setBySiteCoords({ lat, lng });
        const addr = await getAddress({ lat, lng });
        const formatted = getFormattedAddress(
          addr?.objAddress?.address ?? "",
          addr?.objAddress?.address1 ?? "",
          addr?.objAddress?.city ?? "",
          addr?.objAddress?.province ?? "",
          addr?.objAddress?.country ?? "",
          addr?.objAddress?.postalCode ?? "",
          1
        );
        setBySiteLocationText(formatted || "Current Location");
      }

      const latDelta = 0.007;
      const lngDelta = 0.014;

      const payload = {
        Active: 0,
        latitude: lat,
        longitude: lng,
        VP_Latitude_NE: lat + latDelta,
        VP_Latitude_SW: lat - latDelta,
        VP_Longitude_NE: lng + lngDelta,
        VP_Longitude_SW: lng - lngDelta,
        UserId: Number(userId),
        Filters: 0,
        FetchAllowedRecordsOnly: true
      };

      const response = await Postrequestcall(SITE_DETAIL_TYPE, payload, loginData?.accessToken);
      if (response?.status === 200) {
        let sites = response?.data?.data || [];
        if (search?.trim()) {
          const lower = search.toLowerCase();
          sites = sites.filter((site) => {
            const name = (site?.name || site?.siteName || "").toLowerCase();
            const addr = (site?.address || site?.formattedAddress || "").toLowerCase();
            const city = (site?.city || "").toLowerCase();
            const prov = (site?.province || "").toLowerCase();
            return (
              name.includes(lower) ||
              addr.includes(lower) ||
              city.includes(lower) ||
              prov.includes(lower)
            );
          });
        }
        setBySiteList(sites);
      }
    } catch (error) {
      console.error("fetchBySitesForModal error:", error);
    } finally {
      setBySiteLoading(false);
    }
  };

  const fetchProjectsForSiteAccordion = async (siteId) => {
    const numericSiteId = Number(siteId);
    if (!numericSiteId && numericSiteId !== 0) return;

    setSiteProjectsMap((prev) => ({
      ...prev,
      [siteId]: { projects: [], loading: true, count: 0 }
    }));

    try {
      const payload = {
        PageNr: 1,
        NrOfRecPerPage: 100,
        FullSearch: "",
        UserId: Number(userId),
        IncludeRecordNr: "true",
        TypeOfObjectReturned: "",
        FetchAllowedRecordsOnly: false,
        SearchList: [{ siteId: numericSiteId }],
        SortList: [{ FieldName: "id", Direction: "DESC" }]
      };
      const response = await Postrequestcall(FETCH_SITES_PROJECTS, payload, loginData?.accessToken);
      if (response?.status === 200) {
        const projects = response?.data?.data || [];
        setSiteProjectsMap((prev) => ({
          ...prev,
          [siteId]: {
            projects,
            loading: false,
            count: response?.data?.nrOfRecords || projects.length
          }
        }));
      } else {
        setSiteProjectsMap((prev) => ({
          ...prev,
          [siteId]: { projects: [], loading: false, count: 0 }
        }));
      }
    } catch (error) {
      console.error("fetchProjectsForSiteAccordion error:", error);
      setSiteProjectsMap((prev) => ({
        ...prev,
        [siteId]: { projects: [], loading: false, count: 0 }
      }));
    }
  };


  const handleOpenAddProjectForSite = (site) => {
    setSelectedSiteToAddProject(site);
    dispatch(setSelectedsite(site));
    dispatch(setShowaddproject(true));
  };

  const onChooseProjectPressed = () => {
    setProjectSearchText("");
    setBySiteSearchText("");
    setProjectActiveTab("bySite");
    setExpandedSiteId(null);
    fetchBySitesForModal("", bySiteCoords);
    fetchProjectsForModal("", 1, false);
    setOpenProjectListModal(true);
  };


  const handleSelectProjectFromModal = (project) => {
    const projId = project?.id || project?.projectId;
    const projName = project?.name || project?.projectName || "Project";
    const selectedProjData = {
      ...project,
      projectId: projId,
      projectName: projName
    };
    dispatch(setSelectedProjectdata(selectedProjData));
    setQuestionEntityName(projName);
    setAnswer1(projId);
    setOpenProjectListModal(false);
  };



  const fetchUserTicketsForModal = async (search = "") => {
    setTicketModalLoading(true);
    try {
      const ticketObj = {
        UserId: Number(userId),
        PageNo: 1,
        PageSize: 100,
        SearchString: search || ""
      };
      const responses = await Postrequestcall(
        FETCH_TICKETSBY_USERID,
        ticketObj,
        loginData?.accessToken
      );
      const list = responses?.data?.data || [];
      setUserTicketsList(list);
    } catch (error) {
      console.error("fetchUserTicketsForModal error:", error);
    } finally {
      setTicketModalLoading(false);
    }
  };

  const onChooseTicketPressed = () => {
    setTicketSearchText("");
    fetchUserTicketsForModal("");
    setOpenTicketModal(true);
  };

  const handleSelectTicketFromModal = (ticket) => {
    setSelectedTicket(ticket);
    const ticketId = ticket?.id || ticket?.ticketId || ticket?.ticketTypeId;
    const ticketName = ticket?.ticketType || ticket?.ticketName || ticket?.ticketTypeName || ticket?.name || "Ticket";
    setAnswer1(ticketId);
    setQuestionEntityName(ticketName);
    setOpenTicketModal(false);
  };

  const handleTicketCreated = async () => {
    setShowAddTicketModal(false);
    setOpenTicketModal(true);
    setTicketSearchText("");
    setTicketModalLoading(true);
    try {
      const ticketObj = {
        UserId: Number(userId),
        PageNo: 1,
        PageSize: 100,
        SearchString: ""
      };
      const responses = await Postrequestcall(
        FETCH_TICKETSBY_USERID,
        ticketObj,
        loginData?.accessToken
      );
      const list = responses?.data?.data || [];
      setUserTicketsList(list);
      if (list.length > 0) {
        // Pre-select the newly created ticket so it is ready and visible in the modal
        const newestTicket = list[0];
        setSelectedTicket(newestTicket);
        const ticketId = newestTicket?.id || newestTicket?.ticketId || newestTicket?.ticketTypeId;
        const ticketName = newestTicket?.ticketType || newestTicket?.ticketName || newestTicket?.ticketTypeName || newestTicket?.name || "Ticket";
        setAnswer1(ticketId);
        setQuestionEntityName(ticketName);
      }
    } catch (error) {
      console.error("handleTicketCreated error:", error);
    } finally {
      setTicketModalLoading(false);
    }
  };



  const resetOptionState = () => {
    setOptionText("");
    setIsAddTextFieldVisible(false);
    setIsClosing(false);
  };

  const isSubmitDisabled = () => {
    if (props?.question?.quizType === "Select") {
      return options?.filter((item) => item?.isSelected).length === 0;
    } else if (
      props?.question?.response_EntityName == "Project" &&
      props?.question?.response_AttributeName === "Interval"
    ) {
      return !(dayjs.isDayjs(startDate) && dayjs.isDayjs(endDate));
    } else if (
      props?.question?.response_EntityName == "Project" &&
      props?.question?.response_AttributeName !== "Address"
    ) {
      return selectedProject === null;
    } else if (
      props?.question?.response_EntityName?.trim() == "Site" &&
      props?.question?.response_AttributeName !== "Address"
    ) {
      return typeof chooseSite === "undefined" || chooseSite === null;
    } else if (
      props?.question?.response_EntityName?.toLowerCase() === "ticket" ||
      props?.question?.response_EntityName?.toLowerCase() === "tickets"
    ) {
      return !answer1;
    } else {
      return answer1 === "" ? true : false;
    }
  };


  const onChangeAddress = () => {
    let locationModal = {
      ...selectLocation,
      open: true
    };
    dispatch(setSelectlocation(locationModal));
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
        <Card
          className={props?.fromDashboard === "daily-challenge" ? "" : "pagelist-content"}
          sx={{
            backgroundColor: props?.fromDashboard == "new-dashboard" ? BILightGrey : props?.fromDashboard === "daily-challenge" ? "transparent" : "white",
            width: "100%",
            mt: 0,
            border: props?.fromDashboard === "daily-challenge" ? "none" : undefined,
            boxShadow: props?.fromDashboard === "daily-challenge" ? "none" : undefined
          }}>
          <CardContent sx={{ pb: 0, position: "relative" }}>
            {isLoading && (
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  bgcolor: "rgba(255, 255, 255, 0.7)",
                  zIndex: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <CircularProgress />
              </Box>
            )}
            {props?.fromDashboard == "new-dashboard" && (
              <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction="row">
                <Typography>{TEXT_QUESTION_OF_THE_DAY} </Typography>
                <IconButton onClick={() => handleAnswers(2)}>
                  <CloseIcon />
                </IconButton>
              </Stack>
            )}
            <Box>
              {props?.remainingQuestion !== "empty" ? (
                <>
                  <Grid size={{ xs: 12 }}>
                    <Typography variant="h6" sx={{ wordBreak: "break-word" }}>
                      {props?.question?.quizDescription}
                    </Typography>

                    {props?.question?.parameter1?.trim() && (
                      <Box>
                        {(() => {
                          const { quiz_EntityName1, parameter1, parameter1_Name } =
                            props?.question || {};
                          const entityRoutes = {
                            Project: `/project/${Number(parameter1)}`,
                            Company: `/company/${Number(parameter1)}`,
                            Manufacturers: `/manufacturer/${Number(parameter1)}`,
                            Product: `/product/${Number(parameter1)}`,
                            Trade: `/trade/${Number(parameter1)}`
                          };
                          const icons = {
                            Project: <FmdGoodIcon fontSize="small" />,
                            Site: <FmdGoodIcon fontSize="small" />,
                            Role: <FmdGoodIcon fontSize="small" />,
                            "Role/title": <FmdGoodIcon fontSize="small" />,
                            Company: <BusinessCenterIcon fontSize="small" />,
                            Manufacturers: <BusinessCenterIcon fontSize="small" />,
                            Product: <BuildIcon fontSize="small" />,
                            Trade: <ConstructionIcon fontSize="small" />
                          };

                          const isLinkEntity = [
                            "Project",
                            "Company",
                            "Manufacturers",
                            "Product",
                            "Trade",
                            "Site"
                          ].includes(quiz_EntityName1);

                          if (
                            parameter1_Name?.trim() &&
                            quiz_EntityName1 &&
                            icons[quiz_EntityName1]
                          ) {
                            return (
                              <>
                                <IconButton
                                  size="medium"
                                  disableRipple
                                  color="primary"
                                  onClick={() => {
                                    if (entityRoutes[quiz_EntityName1]) {
                                      navigate(entityRoutes[quiz_EntityName1]);
                                      dispatch(setPreviousQuestionId(props?.question?.id));
                                    }
                                  }}>
                                  {icons[quiz_EntityName1]}
                                </IconButton>

                                <Typography
                                  variant="body2"
                                  component="span"
                                  sx={{
                                    cursor: isLinkEntity ? "pointer" : "default",
                                    color: isLinkEntity ? "primary.main" : "text.primary",
                                    fontWeight: "bold",
                                    textDecoration: "none"
                                  }}
                                  onClick={() => {
                                    if (isLinkEntity && entityRoutes[quiz_EntityName1]) {
                                      navigate(entityRoutes[quiz_EntityName1]);
                                      dispatch(setPreviousQuestionId(props?.question?.id));
                                    }
                                  }}>
                                  {parameter1_Name}
                                </Typography>
                              </>
                            );
                          }
                          return null;
                        })()}
                      </Box>
                    )}

                    {props?.question?.parameter1Additional_Name?.trim() && (
                      <Box sx={{ display: "flex" }}>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "text.secondary",
                            paddingLeft: "35px"
                          }}
                          noWrap>
                          {props?.question?.parameter1Additional_Name}
                        </Typography>
                      </Box>
                    )}

                    {props?.question?.parameter2?.trim() && (
                      <Box>
                        {(() => {
                          const { quiz_EntityName2, parameter2, parameter2_Name } =
                            props?.question || {};
                          const entityRoutes = {
                            Project: `/project/${Number(parameter2)}`,
                            Company: `/company/${Number(parameter2)}`,
                            Manufacturers: `/manufacturer/${Number(parameter2)}`,
                            Product: `/product/${Number(parameter2)}`,
                            Trade: `/trade/${Number(parameter2)}`
                          };
                          const icons = {
                            Project: <FmdGoodIcon fontSize="small" />,
                            Site: <FmdGoodIcon fontSize="small" />,
                            "Site  ": <FmdGoodIcon fontSize="small" />,
                            Role: <FmdGoodIcon fontSize="small" />,
                            "Role/title": <FmdGoodIcon fontSize="small" />,
                            Company: <BusinessCenterIcon fontSize="small" />,
                            Manufacturers: <BusinessCenterIcon fontSize="small" />,
                            Product: <BuildIcon fontSize="small" />,
                            Trade: <ConstructionIcon fontSize="small" />
                          };

                          const isLinkEntity = [
                            "Project",
                            "Company",
                            "Manufacturers",
                            "Product",
                            "Trade"
                          ].includes(quiz_EntityName2);

                          if (
                            parameter2_Name?.trim() &&
                            quiz_EntityName2 &&
                            icons[quiz_EntityName2]
                          ) {
                            return (
                              <>
                                <IconButton
                                  size="medium"
                                  disableRipple
                                  color="primary"
                                  onClick={() => {
                                    if (entityRoutes[quiz_EntityName2]) {
                                      navigate(entityRoutes[quiz_EntityName2]);
                                      dispatch(setPreviousQuestionId(props?.question?.id));
                                    }
                                  }}>
                                  {icons[quiz_EntityName2]}
                                </IconButton>

                                <Typography
                                  variant="body2"
                                  component="span"
                                  sx={{
                                    cursor: isLinkEntity ? "pointer" : "default",
                                    color: isLinkEntity ? "primary.main" : "text.primary",
                                    fontWeight: "bold",
                                    textDecoration: "none"
                                  }}
                                  onClick={() => {
                                    if (isLinkEntity && entityRoutes[quiz_EntityName2]) {
                                      navigate(entityRoutes[quiz_EntityName2]);
                                      dispatch(setPreviousQuestionId(props?.question?.id));
                                    }
                                  }}>
                                  {parameter2_Name}
                                </Typography>
                              </>
                            );
                          }
                          return null;
                        })()}
                      </Box>
                    )}

                    {props?.question?.parameter2Additional_Name?.trim() && (
                      <Typography
                        variant="body2"
                        sx={{ color: "text.secondary", paddingLeft: "35px" }}
                        noWrap>
                        {props?.question?.parameter2Additional_Name}
                      </Typography>
                    )}
                  </Grid>

                  {props?.question?.quizType == "Search" ? (
                    <>
                      <Grid size={{ xs: 12, sm: 12, md: props?.from === "daily-challenge" ? 12 : 6 }}>
                        {props?.question?.response_EntityName?.trim() === "Site" ||
                          props?.question?.response_EntityName === "Project" ||
                          props?.question?.response_EntityName?.toLowerCase() === "ticket" ||
                          props?.question?.response_EntityName?.toLowerCase() === "tickets" ||
                          props?.question?.response_EntityName?.trim()?.toLowerCase() === "company" ||
                          props?.question?.response_EntityName?.trim()?.toLowerCase() === "manufacturer" ? (
                          <Box sx={{ padding: "15px 0px" }}>
                            <TextField
                              autoFocus={false}
                              variant="outlined"
                              value={
                                props?.question?.response_EntityName?.trim() === "Site"
                                  ? chooseSite?.name === ""
                                    ? "Unnamed Site"
                                    : chooseSite?.name
                                  : props?.question?.response_EntityName === "Project"
                                  ? (selectedProject?.projectName ?? "")
                                  : (questionEntityName ?? "")
                              }
                              onClick={
                                props?.question?.response_EntityName?.trim() === "Site"
                                  ? onChooseSitePressed
                                  : props?.question?.response_EntityName === "Project"
                                  ? onChooseProjectPressed
                                  : props?.question?.response_EntityName?.trim()?.toLowerCase() === "company" ||
                                    props?.question?.response_EntityName?.trim()?.toLowerCase() === "manufacturer"
                                  ? onChooseCompanyPressed
                                  : onChooseTicketPressed
                              }
                              fullWidth
                              placeholder={`${TEXT_SEARCH_FOR} ${props?.question?.response_EntityName}`}
                              InputProps={{
                                readOnly: true
                              }}
                              sx={{
                                cursor: "pointer",
                                "& .MuiInputBase-root": { cursor: "pointer" },
                                "& .MuiInputBase-input": { cursor: "pointer" }
                              }}
                            />
                          </Box>
                        ) : (

                          <Box sx={{ padding: "15px 0px" }}>
                            <Autocomplete
                              size="small"
                              freeSolo={
                                props?.question?.response_EntityName?.trim()?.toLowerCase() !== "language" &&
                                props?.question?.response_EntityName?.trim()?.toLowerCase() !== "trade"
                              }
                              disabled={props.edit ? true : false}
                              inputValue={questionEntityName}
                              onInputChange={(event, newInputValue, reason) => {
                                if (reason === "input") {
                                  let inputValue = newInputValue.replace(
                                    /^[^A-Za-z]+|(?<=\b\w)[^A-Za-z0-9\s]/g,
                                    ""
                                  );
                                  setQuestionEntityName(inputValue);
                                  questionEntityNameRef.current = inputValue;
                                  setFlag(true);
                                  if (inputValue !== "") {
                                    setIsSearching(true);
                                    isSearchingRef.current = true;
                                    setSearchHasMore(true);
                                    searchHasMoreRef.current = true;
                                    setSearchPage(1);
                                    searchPageRef.current = 1;
                                    listboxScrollTopRef.current = 0;
                                    debouncedGetFilterQuestionData(inputValue);
                                  } else {
                                    setAnswer1("");
                                  }
                                }
                              }}
                              onChange={(event, newValue) => {
                                if (event?.key === "Enter") {
                                  return;
                                }
                                if (newValue && newValue.inputValue) {
                                  let inputValue = newValue.inputValue;
                                  inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                                  setQuestionEntityName(inputValue);
                                  setAnswer1(0);
                                  setFlag(false);
                                } else if (newValue == null) {
                                  setAnswer1("");
                                  setQuestionEntityName(""); // <-- Clear the input value as well
                                  setFlag(false);
                                } else {
                                  setAnswer1(newValue?.id);
                                  setQuestionEntityName(newValue?.title || "");
                                  setFlag(false);
                                }
                              }}
                              filterOptions={(options, params) => {
                                const filtered = [...options];
                                const { inputValue } = params;

                                const isExisting = options.some(
                                  (option) => inputValue?.toLowerCase() === option?.title?.toLowerCase()
                                );

                                const isEntityNoAdd =
                                  props?.question?.response_EntityName?.trim()?.toLowerCase() === "trade" ||
                                  props?.question?.response_EntityName?.trim()?.toLowerCase() === "language";

                                if (inputValue !== "" && !isExisting && !isSearching && !isEntityNoAdd) {
                                  filtered.push({
                                    inputValue,
                                    title: `${TEXT_ADD} "${inputValue}"`
                                  });
                                }
                                return filtered;
                              }}


                              options={filterData}
                              getOptionLabel={(option) => {
                                if (typeof option === "string") {
                                  return option;
                                }
                                if (option.inputValue) {
                                  return option.inputValue;
                                }
                                return option.title;
                              }}
                              getOptionDisabled={(option) => {
                                if (
                                  (props?.question?.response_EntityName === "Company" ||
                                    props?.question?.response_EntityName?.toLowerCase() === "manufacturer") &&
                                  option?.recordStatusId === 3
                                ) {
                                  return true;
                                }
                                return false;
                              }}
                              renderOption={(renderProps, option) => {
                                const { key, ...optionProps } = renderProps;
                                const isReported =
                                  (props?.question?.response_EntityName === "Company" ||
                                    props?.question?.response_EntityName?.toLowerCase() === "manufacturer") &&
                                  option?.recordStatusId === 3;

                                return (
                                  <li key={key} {...optionProps} style={{ pointerEvents: isReported ? "auto" : undefined }}>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
                                      <span>{option?.title}</span>
                                      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                                        {option?.manufacturer && props?.question?.response_EntityName?.toLowerCase() !== "manufacturer" && (
                                          <Box
                                            component="span"
                                            sx={{
                                              fontSize: "0.75rem",
                                              bgcolor: "error.light",
                                              color: "error.contrastText",
                                              px: 1,
                                              py: 0.25,
                                              borderRadius: 1
                                            }}
                                          >
                                            Manufacturer
                                          </Box>
                                        )}
                                        {isReported && (
                                          <IconButton
                                            size="small"
                                            sx={{ color: "error.main" }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              e.preventDefault();
                                              alert(`This ${props?.question?.response_EntityName?.toLowerCase()} is reported`);
                                            }}
                                          >
                                            <WarningIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      </Stack>
                                    </Box>
                                  </li>
                                );
                              }}
                              sx={{ flex: 1 }}
                              loading={isSearching}
                              ListboxProps={{
                                onScroll: (e) => {
                                  const listboxNode = e.currentTarget;
                                  listboxNodeRef.current = listboxNode;
                                  listboxScrollTopRef.current = listboxNode.scrollTop;
                                  const remainingScroll =
                                    listboxNode.scrollHeight -
                                    listboxNode.scrollTop -
                                    listboxNode.clientHeight;
                                  if (
                                    remainingScroll <= 150 &&
                                    !isSearchingRef.current &&
                                    !loadingMoreRef.current &&
                                    searchHasMoreRef.current
                                  ) {
                                    loadingMoreRef.current = true;
                                    getFilterQuestionData(questionEntityNameRef.current, searchPageRef.current + 1);
                                  }
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  autoFocus={false}
                                  {...params}
                                  label={`${TEXT_SEARCH_FOR} ${props?.question?.response_EntityName == "SiteCompanyRole"
                                    ? "Company Role"
                                    : props?.question?.response_EntityName
                                    }`}
                                  variant={"outlined"}
                                  size="small"
                                  InputProps={{
                                    ...(params.InputProps || {}),
                                    endAdornment: (
                                      <>
                                        {(isSearching || loadingMore) ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params?.InputProps?.endAdornment}
                                      </>
                                    ),
                                  }}
                                />
                              )}
                              open={questionEntityName?.length > 1 && flag}
                              onOpen={() => {
                                if (questionEntityName?.length > 1) {
                                  setFlag(true);
                                }
                              }}
                              onClose={() => {
                                setFlag(false);
                              }}
                            />
                          </Box>
                        )}
                      </Grid>

                      {props?.question?.quizType != "Search" && (
                        <Grid size={{ xs: 12 }}>
                          {props?.question?.canAddResponse && props?.question?.maxResponses > 1 && (
                            <div style={{ margin: "5px", marginTop: "0px" }}>
                              <Button
                                color="primary"
                                variant="text"
                                size="small"
                                onClick={() => onAddAnswerPressed()}>
                                {TEXT_ADD_ANSWER}
                              </Button>
                            </div>
                          )}
                        </Grid>
                      )}
                    </>
                  ) : props?.question?.quizType === "Number" ? (
                    <>
                      <Grid size={{ xs: 12, sm: 12, md: props?.from === "daily-challenge" ? 12 : 6 }}>
                        <Box sx={{ padding: "15px 0px" }}>
                          <TextField
                            autoFocus={false}
                            fullWidth
                            label={TEXT_ANSWER}
                            size="small"
                            variant="outlined"
                            value={answer1}
                            onChange={(e) => {
                              let val = e.target.value;
                              const numericValue = val.replace(/^0+|[^0-9]/g, "");
                              setAnswer1(numericValue);
                            }}
                          />
                        </Box>
                      </Grid>
                    </>
                  ) : props?.question?.quizType === "Date" ? (
                    <>
                      <Grid size={{ xs: 12, sm: 12, md: props?.from === "daily-challenge" ? 12 : 6 }}>
                        <Box
                          sx={{ pt: 2, 
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "stretch",
                            gap: 2
                          }}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                enableAccessibleFieldDOMStructure={false}
                                autoFocus={false}
                                yearsPerRow={3}
                                label={TEXT_START_DATE}
                                value={startDate}
                                maxDate={dayjs()}
                                openTo="year"
                                views={["year", "month"]}
                                open={openPicker === "start"}
                                onChange={(newValue) => handleDateChange(newValue, "start")}
                                onClose={() => handlePickerClose("start")}
                                slotProps={{
                                  textField: {
                                    placeholder: TEXT_MONTH_YEAR,
                                    fullWidth: true,
                                    readOnly: true,
                                    onClick: (e) => handleTogglePicker(e, "start"),
                                    onFocus: (e) => {
                                      e.stopPropagation();
                                      e.preventDefault();
                                    }
                                  },
                                  openPickerButton: {
                                    onClick: (e) => handleTogglePicker(e, "start")
                                  },
                                  openPickerIcon: () => <CalendarTodayIcon />
                                }}
                              />

                              <DatePicker
                                enableAccessibleFieldDOMStructure={false}
                                label={TEXT_END_DATE}
                                disabled={currentCompany}
                                value={endDate}
                                maxDate={dayjs()}
                                openTo="year"
                                views={["year", "month"]}
                                open={openPicker === "end"}
                                onChange={(newValue) => handleDateChange(newValue, "end")}
                                onClose={() => handlePickerClose("end")} // Use updated function
                                slotProps={{
                                  textField: {
                                    disabled: currentCompany,
                                    placeholder: TEXT_MONTH_YEAR,
                                    fullWidth: true,
                                    readOnly: true,
                                    onClick: (e) => handleTogglePicker(e, "end"),
                                    onFocus: (e) => {
                                      e.stopPropagation();
                                      e.preventDefault();
                                    }
                                  },
                                  openPickerButton: {
                                    disabled: currentCompany,
                                    onClick: (e) => handleTogglePicker(e, "end")
                                  },
                                  openPickerIcon: () => <CalendarTodayIcon />
                                }}
                              />
                          </LocalizationProvider>
                        </Box>
                      </Grid>
                      <Grid size={{ xs: 12 }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              checked={currentCompany}
                              onChange={onPresentChange}
                            />
                          }
                          label={TEXT_PRESENT}
                        />
                      </Grid>
                    </>
                  ) : props?.question?.quizType === "Select" ? (
                    <Box sx={{ marginLeft: 1, marginBottom: 2 }}>
                      <Box>
                        <Typography variant="body1">
                          {props?.question?.maxResponses === 1
                            ? `${TEXT_SELECT} ${1}`
                            : props?.question?.maxResponses > 1
                              ? `${TEXT_SELECT_UP_TO} ${props?.question?.maxResponses}`
                              : TEXT_SELECT_ALL_THAT_APPLY}
                        </Typography>
                      </Box>

                      {options?.map((op, index) => {
                        return (
                          <div key={index}>
                            <div className="flex-container-horizontal">
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row"
                                }}>
                                <ListItem
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row"
                                  }}
                                  key={index.toString()}
                                  disablePadding>
                                  {!op.isTextField && (
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          color="primary"
                                          checked={op?.isSelected}
                                          onClick={() => onOptionSelected(index)}
                                        />
                                      }
                                    />
                                  )}
                                  {op.isTextField ? (
                                    <>
                                      <TextField
                                        autoFocus={false}
                                        size="small"
                                        variant="outlined"
                                        value={optionText}
                                        onKeyPress={(e) => {
                                          if (e.nativeEvent.key === "Enter") onSubmitOption(index);
                                        }}
                                        fullWidth={props?.from === "dashboard" ? true : false}
                                        onSubmit={() => onSubmitOption(index)}
                                        onChange={(e) => {
                                          let inputValue = e.target.value;
                                          inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                                          setOptionText(inputValue);
                                        }}
                                      />
                                      <IconButton
                                        onClick={(e) => {
                                          onCloseOption(e, index);
                                        }}>
                                        <CloseIcon />
                                      </IconButton>
                                    </>
                                  ) : (
                                    <ListItemText
                                      sx={{ cursor: "pointer" }}
                                      onClick={() => onOptionSelected(index)}>
                                      {op?.optionName?.trim()}
                                    </ListItemText>
                                  )}
                                </ListItem>
                              </div>
                            </div>
                          </div>
                        );
                      })}

                      {props?.question?.canAddResponse && !isAddTextFieldVisible && (
                        <Box>
                          <Button
                            color="primary"
                            variant="text"
                            size="small"
                            onClick={() => onAddOptionPressed()}>
                            {TEXT_ADD_OPTIONS}
                          </Button>
                        </Box>
                      )}
                    </Box>
                  ) : props?.question?.quizType === "Multiline" ? (
                    <Grid size={{ xs: 12, sm: 12, md: props?.from === "daily-challenge" ? 12 : 6 }}>
                      <Box sx={{ padding: "15px 0px" }}>
                        <TextField
                          autoFocus={false}
                          variant="outlined"
                          label={TEXT_ANSWER}
                          slotProps={{
                            input: {
                              multiline: true,
                              inputComponent: "textarea"
                            }
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 1
                            }
                          }}
                          fullWidth
                          value={props?.question?.answer}
                          onChange={(e) => {
                            let inputValue = e.target.value;
                            inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                            setAnswer1(inputValue);
                          }}
                          size="small"
                        />
                      </Box>
                    </Grid>
                  ) : props?.question?.quizType === "Address" ? (
                    <Grid size={{ xs: 12, sm: 12, md: props?.from === "daily-challenge" ? 12 : 6 }}>
                      <Box sx={{ padding: "15px 0px" }}>
                        <TextField
                          autoFocus={false}
                          variant="outlined"
                          label={TEXT_SEARCH_FOR_ADDRESS}
                          fullWidth
                          value={formattedAddress}
                          onClick={() => onChangeAddress()}
                          size="small"
                        />
                      </Box>
                    </Grid>
                  ) : null}
                </>
              ) : (
                <Typography gutterBottom variant="h6" component="div">
                  <Box sx={{ padding: "15px 0px" }}>{props?.question}</Box>
                </Typography>
              )}
              {props?.question !== props?.TEXT_NO_MORE_QUESTIONS && (
                <Grid
                  sx={{
                    display: "flex",
                    justifyContent: props?.from === "daily-challenge" ? "center" : "space-between",
                    flexDirection: "row",
                    mt: 3
                  }}
                  container
                  rowGap={1}
                  width={"100%"}
                >
                  {props?.from !== "daily-challenge" && props?.fromDashboard !== "daily-challenge" && (
                    <Stack sx={{ gap: 1 }} direction={"row"} >
                      <Button
                        variant="outlined"
                        size="small"
                        disabled={isLoading}
                        onClick={() => handleAnswers(2)}>
                        {TEXT_DONT_ASK_BTN}
                      </Button>
                      <Button
                        variant="outlined"
                        disabled={isLoading}
                        size="small"
                        onClick={() => handleAnswers(3)}>
                        {TEXT_ASK_ME_LATER}
                      </Button>
                    </Stack>
                  )}
                  <Stack sx={{ width: props?.from === "daily-challenge" ? "100%" : "auto" }}>
                    <Button
                      variant="contained"
                      fullWidth={props?.from === "daily-challenge"}
                      disabled={isSubmitDisabled() || isLoading}
                      loading={isLoading}
                      onClick={() => handleAnswers(1)}
                      sx={{
                        gap: '6px',
                        textTransform: 'none',
                        py: props?.from === "daily-challenge" ? 1.5 : 1,
                        px: props?.from === "daily-challenge" ? 4 : 2,
                        borderRadius: props?.from === "daily-challenge" ? "12px" : "8px",
                        fontWeight: props?.from === "daily-challenge" ? "800" : "bold",
                        fontSize: props?.from === "daily-challenge" ? "16px" : "14px",
                        backgroundColor: "#083DB8",
                        boxShadow: props?.from === "daily-challenge" ? "0 4px 15px rgba(8, 61, 184, 0.3)" : undefined,
                        "&:hover": {
                          backgroundColor: "#062A85",
                          boxShadow: props?.from === "daily-challenge" ? "0 6px 20px rgba(8, 61, 184, 0.4)" : undefined
                        }
                      }}
                    >
                      {props?.from === "daily-challenge" || props?.fromDashboard === "daily-challenge" ? (
                        TEXT_SUBMIT_BTN
                      ) : (
                        <>
                          {TEXT_SUBMIT_BTN} for {props?.question?.bucks ?? 10}{" "}
                          <img
                            src={bucksIcon}
                            alt="BuilderBucks"
                            style={{ width: 22, height: 22 }}
                          />{" "}
                          BuilderBucks
                        </>
                      )}
                    </Button>
                  </Stack>
                </Grid>
              )}
            </Box>
          </CardContent>
        </Card>
      </Grid>

      {/* Select User Ticket Modal */}
      <Dialog
        open={openTicketModal}
        onClose={() => setOpenTicketModal(false)}
        maxWidth="md"
        fullWidth
        style={{ zIndex: 1400 }}
        sx={{
          zIndex: 1400,
          "& .MuiDialog-paper": {
            borderRadius: 3,
            p: 1
          }
        }}
      >
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1 }}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Select Your Ticket / Certification
          </Typography>
          <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
            <Button
              variant="contained"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => setShowAddTicketModal(true)}
              sx={{
                borderRadius: "50px",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.8rem",
                px: 2
              }}
            >
              Add Ticket
            </Button>
            <IconButton onClick={() => setOpenTicketModal(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent dividers sx={{ minHeight: "350px", maxHeight: "60vh", p: 2 }}>
          <TextField
            fullWidth
            size="small"
            placeholder="Search your tickets..."
            value={ticketSearchText}
            onChange={(e) => {
              const val = e.target.value;
              setTicketSearchText(val);
              fetchUserTicketsForModal(val);
            }}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" fontSize="small" />
                  </InputAdornment>
                ),
                endAdornment: ticketSearchText ? (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={() => {
                        setTicketSearchText("");
                        fetchUserTicketsForModal("");
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ) : null
              }
            }}
            sx={{ mb: 2 }}
          />

          {ticketModalLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 8 }}>
              <CircularProgress size={36} />
            </Box>
          ) : userTicketsList?.length === 0 ? (
            <Box sx={{ textAlign: "center", py: 6, color: "text.secondary" }}>
              <Typography variant="body1" sx={{ fontWeight: 600 }}>
                No tickets found
              </Typography>
              <Typography variant="body2" sx={{ mt: 0.5, mb: 2 }}>
                {ticketSearchText
                  ? `No certifications matched "${ticketSearchText}".`
                  : "You have not added any tickets/certifications yet."}
              </Typography>
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={() => setShowAddTicketModal(true)}
                sx={{ borderRadius: "50px", textTransform: "none", fontWeight: 600 }}
              >
                Add New Ticket
              </Button>
            </Box>
          ) : (
            <Grid container spacing={2}>
              {userTicketsList.map((ticket, index) => {
                const ticketId = ticket?.id || ticket?.ticketId || ticket?.ticketTypeId;
                const ticketTitle =
                  ticket?.ticketType || ticket?.ticketName || ticket?.ticketTypeName || ticket?.name || `Ticket #${index + 1}`;
                const isSelected = answer1 === ticketId;

                return (
                  <Grid key={ticketId || index} size={{ xs: 12, sm: 6, md: 4 }}>
                    <Card
                      variant="outlined"
                      onClick={() => handleSelectTicketFromModal(ticket)}
                      sx={{
                        cursor: "pointer",
                        borderRadius: 2,
                        borderColor: isSelected ? "primary.main" : "divider",
                        borderWidth: isSelected ? 2 : 1,
                        bgcolor: isSelected ? "action.selected" : "background.paper",
                        transition: "all 0.2s ease",
                        "&:hover": {
                          boxShadow: 3,
                          borderColor: "primary.main"
                        }
                      }}
                    >
                      {ticket?.frontPictureUrl && (
                        <CardMedia
                          component="img"
                          height="120"
                          image={ticket?.frontPictureUrl}
                          alt={ticketTitle}
                          sx={{ objectFit: "cover" }}
                        />
                      )}
                      <CardContent sx={{ p: 1.5, "&:last-child": { pb: 1.5 } }}>
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold", color: "text.primary" }}
                          noWrap
                        >
                          {ticketTitle}
                        </Typography>
                        {ticket?.issuedBy && (
                          <Typography variant="caption" sx={{ color: "text.secondary", display: "block" }} noWrap>
                            Issued By: {ticket?.issuedBy}
                          </Typography>
                        )}
                        {ticket?.expiry && (
                          <Typography variant="caption" sx={{ color: "text.secondary", display: "block" }}>
                            Expires: {moment(ticket?.expiry).format("MM/DD/YYYY")}
                          </Typography>
                        )}
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          )}
        </DialogContent>
      </Dialog>

      {/* Add New Ticket Modal */}
      {showAddTicketModal && (
        <AddTicket
          openModal={showAddTicketModal}
          closeModal={() => setShowAddTicketModal(false)}
          fetchUserTicket={handleTicketCreated}
          removeSelectedTickets={() => {}}
          ticketFlag="add"
          editTicketItemDetails={null}
        />
      )}

      {/* Select Site List Modal */}
      <Dialog
        open={openSiteListModal}
        onClose={() => setOpenSiteListModal(false)}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: 3,
            p: 1,
            maxHeight: "85vh"
          }
        }}
      >
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1 }}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Select Site
          </Typography>
          <IconButton onClick={() => setOpenSiteListModal(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ minHeight: "400px", maxHeight: "65vh", p: 2 }}>
          {/* Search Input */}
          <TextField
            fullWidth
            size="small"
            placeholder="Search site by name"
            value={siteSearchText}
            onChange={(e) => {
              setSiteSearchText(e.target.value);
            }}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" fontSize="small" />
                  </InputAdornment>
                ),
                endAdornment: siteSearchText ? (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={() => {
                        setSiteSearchText("");
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ) : null
              }
            }}
            sx={{ mb: 1.5 }}
          />

          {/* Google Places Address Autocomplete & Current Location Bar */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              mb: 2
            }}
          >
            <Box
              sx={{
                flex: 1,
                "& .MuiOutlinedInput-root": {
                  borderRadius: "4px",
                  bgcolor: "background.paper"
                },
                "& .search-location": {
                  borderRadius: "4px"
                }
              }}
            >
              <SearchMap
                setSearchTerm={setSiteLocationText}
                searchTerm={siteLocationText}
                handleSearch={(place) => {
                  if (place?.geometry?.location) {
                    const lat = Number(place.geometry.location.lat());
                    const lng = Number(place.geometry.location.lng());
                    setSiteCoords({ lat, lng });
                    setSiteLocationText(place?.formatted_address || place?.name || "");
                    setSiteSearchText("");
                    fetchSitesForModal("", { lat, lng });
                  }
                }}
                from="site-modal"
                placeholder="Search location / address..."
              />
            </Box>
            <IconButton
              size="medium"
              title="Use current location"
              onClick={async () => {
                setSiteCoords(null);
                setSiteLocationText("");
                setSiteSearchText("");
                fetchSitesForModal("", null);
              }}
              sx={{
                bgcolor: "background.paper",
                border: "1px solid",
                borderColor: "divider",
                color: "primary.main",
                p: 1.1,
                borderRadius: "4px",
                "&:hover": {
                  bgcolor: "action.hover"
                }
              }}
            >
              <MyLocationIcon fontSize="small" />
            </IconButton>
          </Box>




          {/* Site Count Header */}
          <Typography variant="caption" sx={{ color: "text.secondary", display: "block", mb: 1.5, fontWeight: 500 }}>
            {siteList.length} of {totalSiteCount}
          </Typography>

          {/* Site Cards List */}
          {siteListLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 8 }}>
              <CircularProgress size={36} />
            </Box>
          ) : siteList.length === 0 ? (
            <Box sx={{ textAlign: "center", py: 6, color: "text.secondary" }}>
              <Typography variant="body1" sx={{ fontWeight: 600 }}>
                No sites found
              </Typography>
              <Typography variant="body2" sx={{ mt: 0.5 }}>
                {siteSearchText ? `No sites matched "${siteSearchText}".` : "No sites available."}
              </Typography>
            </Box>
          ) : (
            <Stack spacing={1.5}>
              {siteList.map((site, index) => {
                const siteName = site?.name || site?.siteName || "Unnamed Site";
                const siteAddr =
                  site?.formattedAddress ||
                  site?.address ||
                  getFormattedAddress(
                    site?.address ?? "",
                    site?.address1 ?? "",
                    site?.city ?? "",
                    site?.province ?? "",
                    site?.country ?? "",
                    site?.postalCode ?? "",
                    1
                  ) ||
                  (site?.latitude && site?.longitude ? `(${site.latitude}, ${site.longitude})` : "");
                const isSelected = (chooseSite?.id || answer1) === site?.id;

                return (
                  <Box
                    key={site?.id || index}
                    onClick={() => handleSelectSiteFromModal(site)}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      p: 1.5,
                      borderRadius: 2,
                      border: "1px solid",
                      borderColor: isSelected ? "primary.main" : "divider",
                      borderWidth: isSelected ? 2 : 1,
                      bgcolor: isSelected ? "action.selected" : "background.paper",
                      cursor: "pointer",
                      transition: "all 0.15s ease",
                      "&:hover": {
                        boxShadow: 2,
                        borderColor: "primary.main"
                      }
                    }}
                  >
                    <Stack direction="row" spacing={1.5} sx={{ alignItems: "center", flex: 1, minWidth: 0 }}>
                      <Box
                        sx={{
                          width: 44,
                          height: 44,
                          borderRadius: 2,
                          bgcolor: "#f0f4fe",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0
                        }}
                      >
                        <ApartmentIcon sx={{ color: "#083db8", fontSize: 24 }} />
                      </Box>
                      <Box sx={{ minWidth: 0, flex: 1 }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "text.primary" }} noWrap>
                          {siteName}
                        </Typography>
                        {siteAddr && (
                          <Typography variant="caption" sx={{ color: "text.secondary", display: "block" }} noWrap>
                            {siteAddr}
                          </Typography>
                        )}
                      </Box>
                    </Stack>
                    <ArrowForwardIosIcon sx={{ color: "action.disabled", fontSize: 14, ml: 1, flexShrink: 0 }} />
                  </Box>
                );
              })}
            </Stack>
          )}
        </DialogContent>
      </Dialog>

      {/* Select Company / Manufacturer Modal */}
      <CompanySelectModal
        open={openCompanyModal}
        onClose={() => setOpenCompanyModal(false)}
        onSelect={handleSelectCompanyFromModal}
        selectedId={answer1}
        isManufacturerOnly={props?.question?.response_EntityName?.trim()?.toLowerCase() === "manufacturer"}
        title={
          props?.question?.response_EntityName?.trim()?.toLowerCase() === "manufacturer"
            ? "Select Manufacturer"
            : "Select Company"
        }
      />

      {/* Select Project List Modal */}
      <Dialog
        open={openProjectListModal}
        onClose={() => setOpenProjectListModal(false)}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: 3,
            p: 1,
            maxHeight: "85vh"
          }
        }}
      >
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1 }}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Select Project
          </Typography>
          <IconButton onClick={() => setOpenProjectListModal(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          dividers
          onScroll={(e) => {
            if (projectActiveTab !== "allProjects") return;
            const target = e.currentTarget;
            if (
              target.scrollHeight - target.scrollTop - target.clientHeight <= 150 &&
              projectHasMore &&
              !projectLoadingMore &&
              !projectListLoading
            ) {
              fetchProjectsForModal(projectSearchText, projectPage + 1, true);
            }
          }}
          sx={{ minHeight: "400px", maxHeight: "65vh", p: 2 }}
        >
          {/* Tab buttons: By site / All projects */}
          <Box
            sx={{
              display: "flex",
              p: 0.5,
              borderRadius: "50px",
              bgcolor: "#f0f2f5",
              mb: 2
            }}
          >
            <Button
              fullWidth
              size="small"
              startIcon={<ApartmentIcon fontSize="small" />}
              onClick={() => {
                setProjectActiveTab("bySite");
                fetchBySitesForModal(bySiteSearchText);
              }}
              sx={{
                borderRadius: "50px",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.85rem",
                bgcolor: projectActiveTab === "bySite" ? "#083db8" : "transparent",
                color: projectActiveTab === "bySite" ? "#ffffff" : "text.primary",
                "&:hover": {
                  bgcolor: projectActiveTab === "bySite" ? "#083db8" : "action.hover"
                }
              }}
            >
              By site
            </Button>
            <Button
              fullWidth
              size="small"
              startIcon={<BusinessCenterIcon fontSize="small" />}
              onClick={() => {
                setProjectActiveTab("allProjects");
                fetchProjectsForModal(projectSearchText, 1, false);
              }}
              sx={{
                borderRadius: "50px",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.85rem",
                bgcolor: projectActiveTab === "allProjects" ? "#083db8" : "transparent",
                color: projectActiveTab === "allProjects" ? "#ffffff" : "text.primary",
                "&:hover": {
                  bgcolor: projectActiveTab === "allProjects" ? "#083db8" : "action.hover"
                }
              }}
            >
              All projects
            </Button>
          </Box>

          {projectActiveTab === "bySite" ? (
            <>
              {/* Google Places Address Autocomplete & Current Location Bar */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mb: 2
                }}
              >
                <Box
                  sx={{
                    flex: 1,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "4px",
                      bgcolor: "background.paper"
                    },
                    "& .search-location": {
                      borderRadius: "4px"
                    }
                  }}
                >
                  <SearchMap
                    setSearchTerm={setBySiteLocationText}
                    searchTerm={bySiteLocationText}
                    handleSearch={(place) => {
                      if (place?.geometry?.location) {
                        const lat = Number(place.geometry.location.lat());
                        const lng = Number(place.geometry.location.lng());
                        setBySiteCoords({ lat, lng });
                        setBySiteLocationText(place?.formatted_address || place?.name || "");
                        fetchBySitesForModal("", { lat, lng });
                      }
                    }}
                    from="site-modal"
                    placeholder="Search location / address..."
                  />
                </Box>
                <IconButton
                  size="medium"
                  title="Use current location"
                  onClick={async () => {
                    setBySiteCoords(null);
                    setBySiteLocationText("");
                    fetchBySitesForModal("", null);
                  }}
                  sx={{
                    bgcolor: "background.paper",
                    border: "1px solid",
                    borderColor: "divider",
                    color: "primary.main",
                    p: 1.1,
                    borderRadius: "4px",
                    "&:hover": {
                      bgcolor: "action.hover"
                    }
                  }}
                >
                  <MyLocationIcon fontSize="small" />
                </IconButton>
              </Box>


              <Typography variant="caption" sx={{ color: "text.secondary", display: "block", mb: 1.5, fontWeight: 500 }}>
                {bySiteList.length} sites found
              </Typography>


              {bySiteLoading ? (
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 8 }}>
                  <CircularProgress size={36} />
                </Box>
              ) : bySiteList.length === 0 ? (
                <Box sx={{ textAlign: "center", py: 6, color: "text.secondary" }}>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    No sites found
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 0.5 }}>
                    {bySiteSearchText ? `No sites matched "${bySiteSearchText}".` : "No sites available."}
                  </Typography>
                </Box>
              ) : (
                <Stack spacing={1.5}>
                  {bySiteList.map((site, index) => {
                    const siteId = site?.id ?? site?.siteId ?? site?.objData?.id ?? index;
                    const siteName = site?.name || site?.siteName || "Unnamed Site";
                    const siteAddr =
                      site?.formattedAddress ||
                      site?.address ||
                      getFormattedAddress(
                        site?.address ?? "",
                        site?.address1 ?? "",
                        site?.city ?? "",
                        site?.province ?? "",
                        site?.country ?? "",
                        site?.postalCode ?? "",
                        1
                      ) ||
                      (site?.latitude && site?.longitude ? `(${site.latitude}, ${site.longitude})` : "");
                    const isExpanded = expandedSiteId === siteId;
                    const siteProjData = siteProjectsMap[siteId] || { projects: [], loading: false, count: 0 };

                    return (
                      <Accordion
                        key={siteId}
                        expanded={isExpanded}
                        onChange={(e, expanded) => {
                          setExpandedSiteId(expanded ? siteId : null);
                          if (expanded) {
                            fetchProjectsForSiteAccordion(siteId);
                          }
                        }}
                        variant="outlined"
                        sx={{
                          borderRadius: "12px !important",
                          overflow: "hidden",
                          border: "1px solid",
                          borderColor: isExpanded ? "primary.main" : "divider",
                          "&:before": { display: "none" }
                        }}
                      >

                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          sx={{
                            p: 1.5,
                            "& .MuiAccordionSummary-content": {
                              m: 0,
                              alignItems: "center"
                            }
                          }}
                        >
                          <Stack direction="row" spacing={1.5} sx={{ alignItems: "center", flex: 1, minWidth: 0 }}>
                            <Box
                              sx={{
                                width: 44,
                                height: 44,
                                borderRadius: 2,
                                bgcolor: "#f0f4fe",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0
                              }}
                            >
                              <ApartmentIcon sx={{ color: "#083db8", fontSize: 24 }} />
                            </Box>
                            <Box sx={{ minWidth: 0, flex: 1 }}>
                              <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "text.primary" }} noWrap>
                                {siteName}
                              </Typography>
                              {siteAddr && (
                                <Typography variant="caption" sx={{ color: "text.secondary", display: "block" }} noWrap>
                                  {siteAddr}
                                </Typography>
                              )}
                            </Box>
                          </Stack>
                        </AccordionSummary>
                        <AccordionDetails sx={{ pt: 0, pb: 2, px: 2, bgcolor: "#fafbfe" }}>
                          {siteProjData.loading ? (
                            <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                              <CircularProgress size={24} />
                            </Box>
                          ) : (
                            <Stack spacing={1}>
                              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1 }}>
                                <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>
                                  {siteProjData.projects.length} project(s)
                                </Typography>
                                <Button
                                  size="small"
                                  startIcon={<AddIcon />}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleOpenAddProjectForSite(site);
                                  }}
                                  sx={{ textTransform: "none", fontSize: "0.75rem", fontWeight: 600 }}
                                >
                                  Add Project
                                </Button>
                              </Box>


                              {siteProjData.projects.length === 0 ? (
                                <Typography variant="body2" sx={{ color: "text.secondary", textAlign: "center", py: 2 }}>
                                  No projects under this site yet.
                                </Typography>
                              ) : (
                                siteProjData.projects.map((proj, pIdx) => {
                                  const projName = proj?.name || proj?.projectName || "Project";
                                  const isSelected =
                                    (selectedProject?.projectId || selectedProject?.id || answer1) ===
                                    (proj?.id || proj?.projectId);

                                  return (
                                    <Box
                                      key={proj?.id || pIdx}
                                      onClick={() => handleSelectProjectFromModal(proj)}
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        p: 1.25,
                                        borderRadius: 2,
                                        bgcolor: isSelected ? "action.selected" : "background.paper",
                                        border: "1px solid",
                                        borderColor: isSelected ? "primary.main" : "divider",
                                        cursor: "pointer",
                                        transition: "all 0.15s ease",
                                        "&:hover": {
                                          boxShadow: 2,
                                          borderColor: "primary.main"
                                        }
                                      }}
                                    >
                                      <Stack direction="row" spacing={1} sx={{ alignItems: "center", flex: 1, minWidth: 0 }}>
                                        <LocationOnIcon sx={{ color: "#083db8", fontSize: 18 }} />
                                        <Typography variant="body2" sx={{ fontWeight: 600, color: "text.primary" }} noWrap>
                                          {projName}
                                        </Typography>
                                      </Stack>
                                      <ArrowForwardIosIcon sx={{ color: "action.disabled", fontSize: 12 }} />
                                    </Box>
                                  );
                                })
                              )}
                            </Stack>
                          )}
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
                </Stack>
              )}
            </>
          ) : (
            <>
              {/* Search All Projects Input */}
              <TextField
                fullWidth
                size="small"
                placeholder="Select Project"
                value={projectSearchText}
                onChange={(e) => {
                  setProjectSearchText(e.target.value);
                }}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon color="action" fontSize="small" />
                      </InputAdornment>
                    ),
                    endAdornment: projectSearchText ? (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          onClick={() => {
                            setProjectSearchText("");
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ) : null
                  }
                }}
                sx={{ mb: 1.5 }}
              />


              {/* Project Count Header */}
              <Typography variant="caption" sx={{ color: "text.secondary", display: "block", mb: 1.5, fontWeight: 500 }}>
                {projectList.length} of {totalProjectCount}
              </Typography>

              {/* Project Cards List */}
              {projectListLoading ? (
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 8 }}>
                  <CircularProgress size={36} />
                </Box>
              ) : projectList.length === 0 ? (
                <Box sx={{ textAlign: "center", py: 6, color: "text.secondary" }}>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    No projects found
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 0.5 }}>
                    {projectSearchText ? `No projects matched "${projectSearchText}".` : "No projects available."}
                  </Typography>
                </Box>
              ) : (
                <Stack spacing={1.5}>
                  {projectList.map((project, index) => {
                    const projName = project?.name || project?.projectName || "Project";
                    const projAddr =
                      project?.formattedAddress ||
                      project?.address ||
                      project?.siteName ||
                      project?.location ||
                      "";
                    const isSelected =
                      (selectedProject?.projectId || selectedProject?.id || answer1) ===
                      (project?.projectId || project?.id);

                    return (
                      <Box
                        key={project?.id || project?.projectId || index}
                        onClick={() => handleSelectProjectFromModal(project)}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          p: 1.5,
                          borderRadius: 2,
                          border: "1px solid",
                          borderColor: isSelected ? "primary.main" : "divider",
                          borderWidth: isSelected ? 2 : 1,
                          bgcolor: isSelected ? "action.selected" : "background.paper",
                          cursor: "pointer",
                          transition: "all 0.15s ease",
                          "&:hover": {
                            boxShadow: 2,
                            borderColor: "primary.main"
                          }
                        }}
                      >
                        <Stack direction="row" spacing={1.5} sx={{ alignItems: "center", flex: 1, minWidth: 0 }}>
                          <Box
                            sx={{
                              width: 44,
                              height: 44,
                              borderRadius: 2,
                              bgcolor: "#f0f4fe",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0
                            }}
                          >
                            <LocationOnIcon sx={{ color: "#083db8", fontSize: 24 }} />
                          </Box>
                          <Box sx={{ minWidth: 0, flex: 1 }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "text.primary" }} noWrap>
                              {projName}
                            </Typography>
                            {projAddr && (
                              <Typography variant="caption" sx={{ color: "text.secondary", display: "block" }} noWrap>
                                {projAddr}
                              </Typography>
                            )}
                          </Box>
                        </Stack>
                        <ArrowForwardIosIcon sx={{ color: "action.disabled", fontSize: 14, ml: 1, flexShrink: 0 }} />
                      </Box>
                    );
                  })}

                  {projectLoadingMore && (
                    <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
                      <CircularProgress size={24} />
                    </Box>
                  )}
                </Stack>
              )}
            </>
          )}
        </DialogContent>
      </Dialog>

      {/* Add Project Modal Component */}
      <Addproject />
    </Box>
  );
};

export default EarnBuilderBucksCard;





